/* eslint-disable */
//This Page is reponsible for the Technician Patient Details
import React, { useState, useEffect, useRef, useMemo } from "react";
import { db, storage } from "../../firebase-config";
import {
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
  listAll,
  deleteObject,
} from "firebase/storage";
import {
  ref,
  onValue,
  get,
  set,
  runTransaction,
  push,
  query,
  orderByKey,
  orderByChild,
  limitToFirst,
  limitToLast,
  startAfter,
  endBefore,
  endAt,
  startAt,
  onChildAdded,
  onChildChanged,
  onChildRemoved,
  off,
} from "firebase/database";
import "./ListOfPatientDe1.css";
import "../../AdminPages/AssignDoctor/AssignDoctor.css";
import ChatNot from "../../components/Chat/ChatNot";
import "../../components/Chat/ChatNot.css";
import { Link, useNavigate } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useUserAuth } from "../../context/UserAuthContext";
import CryptoJS from "crypto-js"; // Importing CryptoJS for encryption and decryption
import AddIcon from "@mui/icons-material/Add";
import HistoryIcon from "@mui/icons-material/History";
import DownloadIcon from "@mui/icons-material/Download";
import ShareIcon from "@mui/icons-material/Share";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ThreeDRotationIcon from "@mui/icons-material/ThreeDRotation";
import Tooltip from "@mui/material/Tooltip";
import DescriptionIcon from "@mui/icons-material/Description";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import FileDownloadOffOutlinedIcon from "@mui/icons-material/FileDownloadOffOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
//import DoDisturbOutlinedIcon from "@mui/icons-material/DoDisturbOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import AddPatientTech from "../AddPatientTech/AddPatientTech";
import OrthancServerData from "../OrthancServerData/OrthancServerData";
import { Button, Dropdown } from "react-bootstrap"; // Add Dropdown import
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrescription } from "@fortawesome/free-solid-svg-icons"; // adjust the import if needed
import { getStorage } from "firebase/storage";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import MinimizeIcon from "@mui/icons-material/Minimize";
// ---- Import the new AI architecture classes/config:
import { AIModelHandler } from "../../API/AIModelHandler"; // <-- Update with the correct path
// -----------------------------------------------------
// deepa audit: Import audit logging helpers
import {
  logBulkAssignmentTech,
  logIndividualAssignmentTech,
  logReportReadTech,
  logReportDownloadTech,
  logClinicalHistoryTech,
  logShareEventTech,
  logViewDicomTechnician,
  logViewPrescriptionTechnician,
  logAIModelRunTechnician,
  logReportReadAssignmentTech, //deepaaudit logs: import for AI model run logging
} from "../AddPatientTech/TechAuditLogs";
// deepa audit: Import audit log viewer component
import DropdownCell from "../../components/DropdownCell/DropdownCell";
// Converts any value to a trimmed string if possible,
// and returns null if the resulting string is empty or one of the disallowed values.
const getValidString = (value) => {
  if (value === null || value === undefined) return null;
  let str = typeof value === "string" ? value.trim() : String(value).trim();
  if (!str) return null;
  const disallowed = ["NA", "NOT UPLOADED", "N/A"];
  if (disallowed.includes(str.toUpperCase())) return null;
  return str;
};

const isBase64 = (str) => {
  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
};

const decrypt = (encryptedData) => {
  try {
    // Check if the data is encrypted (base64 encoded) before trying to decrypt it
    if (!isBase64(encryptedData)) {
      return encryptedData; // If it's not base64, it's probably not encrypted
    }
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    
    // Try to convert to UTF-8, catch malformed data errors
    try {
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      // If decryption succeeds and returns a non-empty string, use it
      if (decrypted && decrypted.length > 0) {
        return decrypted;
      }
    } catch (utf8Error) {
      // Malformed UTF-8 data means this wasn't encrypted data, return original
      return encryptedData;
    }

    // If decryption returns empty string, return the original data
    return encryptedData;
  } catch (error) {
    // Silent fail for invalid encrypted data - return original
    return encryptedData;
  }
};
// Function to encrypt data using CryptoJS and secret key
const encrypt = (data) => {
  const secretKey = process.env.REACT_APP_SECRET_KEY; // HIPAA-compliant secret key stored securely
  return CryptoJS.AES.encrypt(data, secretKey).toString();
};

// Function to decrypt data using CryptoJS and secret key
const decryptData = (encryptedData) => {
  try {
    const secretKey = process.env.REACT_APP_SECRET_KEY; // HIPAA-compliant secret key
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8); // Convert decrypted bytes to string
  } catch (error) {
    console.warn("Error decrypting data:", error);
    return encryptedData; // Return original data if decryption fails
  }
};

// Function to check if the data is encrypted and decrypt if needed
const decryptDataIfNeeded = (data) => {
  if (typeof data === "string" && data.startsWith("U2FsdGVkX1")) {
    return decryptData(data);
  }
  return data;
};

// Function to decrypt keys and make them Firebase-safe
const decryptKey = (encryptedKey) => {
  try {
    const base64String = encryptedKey.replace(/_/g, "/").replace(/-/g, "+");
    const encrypted = atob(base64String);
    return decrypt(encrypted);
  } catch (error) {
    return encryptedKey;
  }
};

const decryptField = (field) => {
  if (!field) return "";
  if (Array.isArray(field)) {
    return field.map((item) => decrypt(item));
  }
  return decrypt(field);
};

// Helper function to get patient data (handles both encrypted and plain text)
const getPatientData = (patientData, fieldName) => {
  if (!patientData) return null;

  // First try direct field access (for legacy plain text data)
  if (patientData[fieldName] !== undefined && patientData[fieldName] !== null) {
    return decryptField(patientData[fieldName]);
  }

  // Then try to find encrypted key version
  for (const key in patientData) {
    try {
      const decryptedKey = decryptKey(key);
      if (decryptedKey === fieldName) {
        return decryptField(patientData[key]);
      }
    } catch (error) {
      continue; // Continue to next key if decryption fails
    }
  }

  return null;
};

// Main Component for displaying and managing the list
const ListOfPatient = () => {
  const [posts, setPosts] = useState({});
  const [doctors, setDoctors] = useState({});
  const [searchTerms, setSearchTerms] = useState({
    patientId: "",
    fullName: "",
    modality: "",
    centerName: "",
    status: "",
  });
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedLink, setSelectedLink] = useState("");
  const [selectedPatients, setSelectedPatients] = useState([]);
  const [currentPatientsAi, setCurrentPatientsAi] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [patientsPerPage] = useState(20);
  const [isEditing, setIsEditing] = useState(false); // To track whether the user is in edit mode
  
  /* 
   * BATCH LOADING SYSTEM
   * ====================
   * Instead of loading all patients at once, we load them in batches of 100.
   * This significantly improves initial load time and reduces memory usage.
   * 
   * How it works:
   * 1. On mount: Fetch all patient keys + timestamps (lightweight)
   * 2. Load first batch (0-99): Full patient data for display
   * 3. On page change: Automatically load required batch if not already loaded
   * 4. Preloading: Next batch is loaded in background for smoother navigation
   * 
   * Example with 1000 patients:
   * - Page 1-5: Shows patients from Batch 0 (patients 0-99)
   * - Page 6-10: Shows patients from Batch 1 (patients 100-199) - loaded when navigating
   * - Page 11-15: Shows patients from Batch 2 (patients 200-299) - etc.
   * 
   * Benefits:
   * - Faster initial page load
   * - Lower memory consumption
   * - Better performance with large datasets
   * - Smooth user experience with preloading
   */
  const [batchSize] = useState(100); // Fetch 100 patients per batch
  const [loadedBatches, setLoadedBatches] = useState(new Set()); // Track which batches are loaded
  const [totalPatientCount, setTotalPatientCount] = useState(0); // Total number of patients
  const [isLoadingBatch, setIsLoadingBatch] = useState(false); // Loading state for batch fetching
  const [allPatientKeys, setAllPatientKeys] = useState([]); // Store all patient keys for pagination
  const [hasMorePatients, setHasMorePatients] = useState(true); // Track if more patients can be loaded
  const [oldestTimestamp, setOldestTimestamp] = useState(null); // Track oldest timestamp for pagination
  const [isSearchingFirebase, setIsSearchingFirebase] = useState(false); // Track if currently searching Firebase
  const [isInitialBatchLoaded, setIsInitialBatchLoaded] = useState(false); // Track if initial batch is loaded

  const [bulkAssignModalVisible, setBulkAssignModalVisible] = useState(false);
  const [unassignedPatients, setUnassignedPatients] = useState([]);
  const [bulkSelectedPatients, setBulkSelectedPatients] = useState([]);
  const [bulkSelectedDoctor, setBulkSelectedDoctor] = useState("");
  const [loading, setLoading] = useState(false);
  const [statusMessages, setStatusMessages] = useState({});
  const [progressPercentages, setProgressPercentages] = useState({});
  const [clinicalHistoryModalVisible, setClinicalHistoryModalVisible] =
    useState(false);
  const [selectedPatientId, setSelectedPatientId] = useState("");
  const [clinicalHistoryText, setClinicalHistoryText] = useState("");
  const [attachedFile, setAttachedFile] = useState(null); // For attached file
  const [loadingAI, setLoadingAI] = useState({});
  const [selectedDropdownId, setSelectedDropdownId] = useState(null);
  const dropdownRef = useRef(null);

  //state for choosing ai model
  const [aiModalVisible, setAiModalVisible] = useState(false);
  const [aiModalPatientId, setAiModalPatientId] = useState(null);
  const [showContouringSubMenu, setShowContouringSubMenu] = useState(false);
  const [aiModelsEnabled, setAiModelsEnabled] = useState({});
  const [selectedAIModel, setSelectedAIModel] = useState("");

  // wallet related states:
  const [costingType, setCostingType] = useState(""); // e.g. "Prepaid", "Postpaid", etc.
  const [walletBalance, setWalletBalance] = useState(0);
  const [boneFractureCost, setBoneFractureCost] = useState(0);
  const [contouringModelCost, setContouringModelCost] = useState(0);
  const [tbModelCost, setTbModelCost] = useState(0);
  const [cxrTbCost, setCxrTbCost] = useState(0);
  const [cxrTb2Cost, setCxrTb2Cost] = useState(0);
  const [cxrMulticlassCost, setCxrMulticlassCost] = useState(0);
  const [xrayFractureCost, setXrayFractureCost] = useState(0);
  const [threeDAbdomenCost, setThreeDAbdomenCost] = useState(0);
  const [tumorAbdomenCost, setTumorAbdomenCost] = useState(0);
  const [contourAbdomenCost, setContourAbdomenCost] = useState(0);
  // 1. Add state for Liver-Segmentation cost
  const [liverSegmentationCost, setLiverSegmentationCost] = useState(0);
  // 2. Add state for Contour-HaN cost
  const [contourHaNModelCost, setContourHaNModelCost] = useState(0);

  // We'll keep an array "aiTasks" describing each active or completed AI request
  // => an array of { patientId, model, subModel, status }
  const [aiTasks, setAiTasks] = useState([]);

  // For the AI Processing Status modal
  const [aiProcessingModalOpen, setAiProcessingModalOpen] = useState(false);
  const [aiProcessingModalMinimized, setAiProcessingModalMinimized] =
    useState(false);
  // deepa audit: state for audit log modal visibility
  const [auditLogModalVisible, setAuditLogModalVisible] = useState(false);

  const intervalsRef = useRef({});

  const { logOut } = useUserAuth();
  const navigate = useNavigate();
  // Local storage value for admin name
  const adminName1 = localStorage.getItem("adminName");

  const [isAddingPatient, setIsAddingPatient] = useState(false);
  const techname = localStorage.getItem("Name");
  const toggleAddPatientView = () => {
    navigate("/Technician/AddPatient");
  };
  // 18feb string issue
  const getValidReportURL = (value) => {
    return getValidString(value); // Uses the previously defined getValidString function
  };

  // 1. get wallet/costing
  useEffect(() => {
    if (adminName1) {
      // Wallet balance
      const walletBalanceRef = ref(
        db,
        `superadmin/admins/${adminName1}/Wallet/Wallet_Balance`
      );
      const unsubscribeWallet = onValue(walletBalanceRef, (snapshot) => {
        if (snapshot.exists()) {
          setWalletBalance(snapshot.val());
        }
      });

      // bone fracture
      const boneFractureCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/XRay-Fracture`
      );
      get(boneFractureCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setBoneFractureCost(snapshot.val());
        } else {
          setBoneFractureCost(0);
        }
      });

      // contouring
      const contouringCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/Contour-Abdomen`
      );
      get(contouringCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setContouringModelCost(snapshot.val());
        } else {
          setContouringModelCost(0);
        }
      });

      // costingType
      const costingTypeRef = ref(
        db,
        `superadmin/admins/${adminName1}/CostingType`
      );
      get(costingTypeRef).then((snapshot) => {
        if (snapshot.exists()) {
          setCostingType(snapshot.val());
        } else {
          setCostingType("");
        }
      });

      // tbModelCost
      const tbModelCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/CXR-TB`
      );
      get(tbModelCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setTbModelCost(snapshot.val());
        } else {
          setTbModelCost(0);
        }
      });

      // CXR-TB Cost
      const cxrTbCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/CXR-TB`
      );
      get(cxrTbCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setCxrTbCost(snapshot.val());
        } else {
          setCxrTbCost(0);
        }
      });

      // CXR-TB2 Cost
      const cxrTb2CostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/CXR-TB2`
      );
      get(cxrTb2CostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setCxrTb2Cost(snapshot.val());
        } else {
          setCxrTb2Cost(0);
        }
      });

      // CXR-Multiclass Cost
      const cxrMulticlassCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/CXR-Multiclass`
      );
      get(cxrMulticlassCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setCxrMulticlassCost(snapshot.val());
        } else {
          setCxrMulticlassCost(0);
        }
      });

      // XRay-Fracture Cost
      const xrayFractureCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/XRay-Fracture`
      );
      get(xrayFractureCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setXrayFractureCost(snapshot.val());
        } else {
          setXrayFractureCost(0);
        }
      });

      // 3D-Abdomen Cost
      const threeDAbdomenCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/3D-Abdomen`
      );
      get(threeDAbdomenCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setThreeDAbdomenCost(snapshot.val());
        } else {
          setThreeDAbdomenCost(0);
        }
      });

      // Tumor-Abdomen Cost
      const tumorAbdomenCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/Tumor-Abdomen`
      );
      get(tumorAbdomenCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setTumorAbdomenCost(snapshot.val());
        } else {
          setTumorAbdomenCost(0);
        }
      });

      // Contour-Abdomen Cost
      const contourAbdomenCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/Contour-Abdomen`
      );
      get(contourAbdomenCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setContourAbdomenCost(snapshot.val());
        } else {
          setContourAbdomenCost(0);
        }
      });

      // Liver-Segmentation cost
      const liverSegmentationCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/Liver-Segmentation`
      );
      get(liverSegmentationCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setLiverSegmentationCost(snapshot.val());
        } else {
          setLiverSegmentationCost(0);
        }
      });

      // Contour-HaN cost
      const contourHaNModelCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/Contour-HaN`
      );
      get(contourHaNModelCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setContourHaNModelCost(snapshot.val());
        } else {
          setContourHaNModelCost(0);
        }
      });

      return () => {
        unsubscribeWallet();
      };
    }
  }, [adminName1]);

  // 2. get ai models enabled
  useEffect(() => {
    if (adminName1) {
      const aiEnabledRef = ref(
        db,
        `superadmin/admins/${adminName1}/AI_Model_Enabled`
      );
      onValue(aiEnabledRef, (snapshot) => {
        if (snapshot.exists()) {
          setAiModelsEnabled(snapshot.val());
        } else {
          setAiModelsEnabled({});
        }
      });
    }
  }, [adminName1]);

  // Helper function to process patient data
  const processPatientData = (id, patient) => {
    if (!patient) return null;
    
    const version = patient.Version || "1";
    
    // Normalize DoctorAssigned field
    let DoctorAssigned = patient.DoctorAssigned;
    if (DoctorAssigned) {
      if (Array.isArray(DoctorAssigned)) {
        DoctorAssigned = DoctorAssigned.map((doctor) => {
          if (typeof doctor === "string") {
            const cleanName = doctor.trim().toLowerCase();
            if (
              cleanName === "" ||
              cleanName === "doctor common" ||
              cleanName === "doctorcommon" ||
              cleanName === "null" ||
              cleanName === "undefined"
            ) {
              return null;
            }
            return { name: doctor };
          } else if (
            typeof doctor === "object" &&
            doctor !== null &&
            doctor.name
          ) {
            const cleanName = doctor.name.trim().toLowerCase();
            if (
              cleanName === "" ||
              cleanName === "doctor common" ||
              cleanName === "doctorcommon" ||
              cleanName === "null" ||
              cleanName === "undefined"
            ) {
              return null;
            }
            return doctor;
          } else {
            return null;
          }
        }).filter((doctor) => doctor !== null);
      } else {
        DoctorAssigned = [];
      }
    } else {
      DoctorAssigned = [];
    }

    if (version === "3" || version === "03") {
      const uploads = patient.uploads || {};
      const scanKeys = Object.keys(uploads)
        .filter((key) => key.toLowerCase().startsWith("scan"))
        .map((key) => ({
          key,
          number: parseInt(key.replace(/\D/g, ""), 10) || 0,
        }))
        .sort((a, b) => b.number - a.number);

      let latestScanData = {};
      if (scanKeys.length > 0) {
        const latestScanKey = scanKeys[0].key;
        latestScanData = uploads[latestScanKey];
      }

      // PRIORITY LOGIC FOR Dicom_ReportURL - Check all scans, then fallback to main patient node
      let foundReportURL = "";
      
      // Priority 1: Check ALL scans for valid Dicom_ReportURL (latest first)
      for (const { key } of scanKeys) {
        const upload = uploads[key];
        const reportURL = upload?.Dicom_ReportURL;
        
        if (reportURL && reportURL !== "NA" && reportURL !== "" && reportURL !== "null") {
          foundReportURL = reportURL;
          break; // Use first valid report found
        }
      }
      
      // Priority 2: Fallback to main patient node if not found in any scan
      if (!foundReportURL && patient.Dicom_ReportURL) {
        const mainReportURL = patient.Dicom_ReportURL;
        if (mainReportURL && mainReportURL !== "NA" && mainReportURL !== "" && mainReportURL !== "null") {
          foundReportURL = mainReportURL;
        }
      }

      return {
        id,
        version: "3",
        ...patient,
        FullName: decryptDataIfNeeded(patient.FullName),
        Age: decryptDataIfNeeded(patient.Age),
        Gender: decryptDataIfNeeded(patient.Gender),
        ID: decryptDataIfNeeded(patient.ID),
        DoctorAssigned: DoctorAssigned,
        Dicom_3D: latestScanData.Dicom_3D || "NA",
        Dicom_3DURL: decryptDataIfNeeded(latestScanData.Dicom_3DURL) || "NA",
        Dicom_Report: latestScanData.Dicom_Report || "NA",
        Dicom_ReportURL: foundReportURL ? decryptDataIfNeeded(foundReportURL) : "NA",
        FolderPath: decryptDataIfNeeded(latestScanData.FolderPath) || "NA",
        Modality: latestScanData.Modality || "NA",
        StudyDate: latestScanData.StudyDate || "NA",
        PrescriptionURL: decryptDataIfNeeded(latestScanData.PrescriptionURL) || "NA",
      };
    } else {
      return {
        id,
        version,
        ...patient,
        FullName: decryptDataIfNeeded(patient.FullName),
        Age: decryptDataIfNeeded(patient.Age),
        Gender: decryptDataIfNeeded(patient.Gender),
        ID: decryptDataIfNeeded(patient.ID),
        DoctorAssigned: DoctorAssigned,
        Modality: decryptDataIfNeeded(patient.Modality) || "NA",
        StudyDate: decryptDataIfNeeded(patient.StudyDate) || "NA",
        Dicom_3D: decryptDataIfNeeded(patient.Dicom_3D) || "NA",
        Dicom_3DURL: decryptDataIfNeeded(patient.Dicom_3DURL) || "NA",
        Dicom_Report: decryptDataIfNeeded(patient.Dicom_Report) || "NA",
        Dicom_ReportURL: decryptDataIfNeeded(patient.Dicom_ReportURL) || "NA",
        FolderPath: decryptDataIfNeeded(patient.FolderPath) || "NA",
      };
    }
  };
  
  // Fetch patient keys using Firebase orderByChild query
  // This fetches ONLY the latest patients using server-side filtering
  const fetchPatientKeys = async () => {
    if (!adminName1) return;
    
    try {
      const startTime = performance.now();
      
      // Create a query to get latest 100 patients sorted by Timestamp
      const patientsRef = ref(db, `superadmin/admins/${adminName1}/patients`);
      const latestQuery = query(
        patientsRef,
        orderByChild('Timestamp'),
        limitToLast(100)  // Fetch latest 100 patients
      );
      
      const snapshot = await get(latestQuery);
      const latestPatients = snapshot.val();
      
      if (!latestPatients) {
        setTotalPatientCount(0);
        setAllPatientKeys([]);
        setPosts({});
        return;
      }
      
      // Convert to array and sort (reverse for latest first)
      const keysWithTimestamp = Object.keys(latestPatients).map(id => ({
        id,
        timestamp: latestPatients[id]?.Timestamp || "1970-01-01T00:00:00"
      }));
      
      // Sort by timestamp (latest first)
      keysWithTimestamp.sort((a, b) => {
        const dateA = new Date(a.timestamp);
        const dateB = new Date(b.timestamp);
        return dateB - dateA;
      });
      
      const sortedKeys = keysWithTimestamp.map(item => item.id);
      
      // Track the oldest timestamp for loading more patients
      if (keysWithTimestamp.length > 0) {
        const oldestPatient = keysWithTimestamp[keysWithTimestamp.length - 1];
        setOldestTimestamp(oldestPatient.timestamp);
      }
      
      // Check if we got fewer than 100 patients (means no more to load)
      setHasMorePatients(keysWithTimestamp.length >= 100);
      
      // Process and decrypt patient data before storing
      const processedPatients = {};
      Object.keys(latestPatients).forEach((patientId) => {
        const processed = processPatientData(patientId, latestPatients[patientId]);
        if (processed) {
          processedPatients[patientId] = processed;
        }
      });
      
      setAllPatientKeys(sortedKeys);
      setTotalPatientCount(sortedKeys.length);
      setPosts(processedPatients);
      setIsInitialBatchLoaded(true); // Mark initial batch as loaded
      
    } catch (error) {
      console.error("Error fetching patients:", error);
    }
  };

  // Load more patients (next 100)
  const loadMorePatients = async () => {
    if (!adminName1 || !hasMorePatients || isLoadingBatch || !oldestTimestamp) return;
    
    try {
      setIsLoadingBatch(true);
      
      // Query for next 100 patients before the oldest timestamp
      const patientsRef = ref(db, `superadmin/admins/${adminName1}/patients`);
      const nextQuery = query(
        patientsRef,
        orderByChild('Timestamp'),
        endBefore(oldestTimestamp),
        limitToLast(100)
      );
      
      const snapshot = await get(nextQuery);
      const morePatients = snapshot.val();
      
      if (!morePatients || Object.keys(morePatients).length === 0) {
        setHasMorePatients(false);
        setIsLoadingBatch(false);
        return;
      }
      
      // Convert to array and sort
      const keysWithTimestamp = Object.keys(morePatients).map(id => ({
        id,
        timestamp: morePatients[id]?.Timestamp || "1970-01-01T00:00:00"
      }));
      
      keysWithTimestamp.sort((a, b) => {
        const dateA = new Date(a.timestamp);
        const dateB = new Date(b.timestamp);
        return dateB - dateA;
      });
      
      const newKeys = keysWithTimestamp.map(item => item.id);
      
      // Update oldest timestamp for next load
      if (keysWithTimestamp.length > 0) {
        const oldestPatient = keysWithTimestamp[keysWithTimestamp.length - 1];
        setOldestTimestamp(oldestPatient.timestamp);
      }
      
      // Check if there are more patients
      setHasMorePatients(keysWithTimestamp.length >= 100);
      
      // Process and decrypt patient data before storing
      const processedMorePatients = {};
      Object.keys(morePatients).forEach((patientId) => {
        const processed = processPatientData(patientId, morePatients[patientId]);
        if (processed) {
          processedMorePatients[patientId] = processed;
        }
      });
      
      // Append new patients to existing
      setAllPatientKeys(prev => [...prev, ...newKeys]);
      setTotalPatientCount(prev => prev + newKeys.length);
      setPosts(prev => ({ ...prev, ...processedMorePatients }));
      
    } catch (error) {
      console.error("Error loading more patients:", error);
    } finally {
      setIsLoadingBatch(false);
    }
  };

  // Load a specific batch of patients (uses in-memory data)
  const loadPatientBatch = async (batchNumber) => {
    if (!adminName1 || loadedBatches.has(batchNumber) || isLoadingBatch || allPatientKeys.length === 0) {
      return;
    }

    setIsLoadingBatch(true);
    
    try {
      // Calculate batch range
      const startIndex = batchNumber * batchSize;
      const endIndex = Math.min(startIndex + batchSize, allPatientKeys.length);
      const batchKeys = allPatientKeys.slice(startIndex, endIndex);

      const batchData = {};
      
      // Data is already processed and stored in posts, just use it directly
      batchKeys.forEach((patientId) => {
        if (posts[patientId]) {
          batchData[patientId] = posts[patientId];
        }
      });

      // Merge with existing posts
      setPosts((prevPosts) => ({
        ...prevPosts,
        ...batchData,
      }));

      // Mark batch as loaded
      setLoadedBatches((prev) => new Set([...prev, batchNumber]));
    } catch (error) {
      console.error("Error loading patient batch:", error);
    } finally {
      setIsLoadingBatch(false);
    }
  };

  /* Fetch patient keys on mount */
  useEffect(() => {
    if (adminName1) {
      setIsInitialBatchLoaded(false); // Reset initial batch flag
      fetchPatientKeys();
    }
  }, [adminName1]);

  /* Global real-time listener for all patient changes */
  useEffect(() => {
    if (!adminName1) return;

    const patientsRef = ref(db, `superadmin/admins/${adminName1}/patients`);
    
    // Track if this is the initial mount to prevent duplicate additions
    let isInitialLoad = true;
    const initialLoadTimer = setTimeout(() => {
      isInitialLoad = false;
    }, 2000); // Increased timeout to ensure initial batch load completes

    // Listen for new patients being added
    const handleChildAdded = onChildAdded(patientsRef, (snapshot) => {
      // Skip initial load to prevent duplicates
      if (isInitialLoad) return;
      
      const patientId = snapshot.key;
      const patientData = snapshot.val();
      
      // Check if we already have this patient
      setPosts(prev => {
        if (prev[patientId]) {
          return prev; // Already exists, don't add
        }
        
        // Only add new patients if initial batch is loaded (allow real-time updates after initial load)
        if (!isInitialBatchLoaded) {
          return prev; // Don't add during initial batch loading
        }
        
        // Allow real-time updates to show immediately after initial batch is loaded
        
        // Process and add new patient to top
        const processed = processPatientData(patientId, patientData);
        if (processed) {
          // Add to top of the list
          const updated = { [patientId]: processed, ...prev };
          
          // Update patient keys and count
          setAllPatientKeys(prevKeys => {
            if (!prevKeys.includes(patientId)) {
              return [patientId, ...prevKeys];
            }
            return prevKeys;
          });
          setTotalPatientCount(prevCount => {
            const currentCount = Object.keys(updated).length;
            return currentCount;
          });
          
          return updated;
        }
        return prev;
      });
    });

    // Listen for patient data changes
    const handleChildChanged = onChildChanged(patientsRef, (snapshot) => {
      const patientId = snapshot.key;
      const patientData = snapshot.val();
      
      setPosts(prev => {
        const exists = prev[patientId];
        
        // Update existing patient data
        const processed = processPatientData(patientId, patientData);
        if (processed) {
          if (exists) {
            // Update existing patient
            return { ...prev, [patientId]: processed };
          } else {
            // Patient was added (shouldn't happen often, but handle it) - allow after initial load
            if (!isInitialBatchLoaded) {
              return prev; // Don't add during initial batch loading
            }
            
            // Allow real-time updates to show immediately after initial batch is loaded
            setAllPatientKeys(prevKeys => {
              if (!prevKeys.includes(patientId)) {
                return [patientId, ...prevKeys];
              }
              return prevKeys;
            });
            setTotalPatientCount(prevCount => prevCount + 1);
            return { [patientId]: processed, ...prev };
          }
        }
        
        return prev;
      });
    });

    // Listen for patient deletions
    const handleChildRemoved = onChildRemoved(patientsRef, (snapshot) => {
      const patientId = snapshot.key;
      
      setPosts(prev => {
        const exists = prev[patientId];
        if (exists) {
          const updated = { ...prev };
          delete updated[patientId];
          
          setAllPatientKeys(prevKeys => prevKeys.filter(key => key !== patientId));
          setTotalPatientCount(prevCount => Math.max(0, prevCount - 1));
          return updated;
        }
        return prev;
      });
    });

    // Cleanup function
    return () => {
      clearTimeout(initialLoadTimer);
      off(patientsRef, 'child_added', handleChildAdded);
      off(patientsRef, 'child_changed', handleChildChanged);
      off(patientsRef, 'child_removed', handleChildRemoved);
    };
  }, [adminName1, isInitialBatchLoaded, patientsPerPage]);

  /* Load initial batch after keys are fetched */
  useEffect(() => {
    if (adminName1 && allPatientKeys.length > 0 && loadedBatches.size === 0) {
      loadPatientBatch(0); // Load first batch
    }
  }, [adminName1, allPatientKeys]);

  /* Load additional batches based on current page */
  useEffect(() => {
    if (!adminName1 || allPatientKeys.length === 0) return;

    // Calculate which batch the current page needs
    const requiredBatch = Math.floor(((currentPage - 1) * patientsPerPage) / batchSize);
    
    // Load the required batch if not already loaded
    if (!loadedBatches.has(requiredBatch)) {
      loadPatientBatch(requiredBatch);
    }

    // Preload next batch for smoother experience
    const nextBatch = requiredBatch + 1;
    const maxBatch = Math.ceil(allPatientKeys.length / batchSize) - 1;
    if (nextBatch <= maxBatch && !loadedBatches.has(nextBatch)) {
      setTimeout(() => loadPatientBatch(nextBatch), 500);
    }
  }, [currentPage, adminName1, loadedBatches, allPatientKeys]);

  useEffect(() => {
    const docRef = ref(db, `superadmin/admins/${adminName1}/doctors`);
    onValue(docRef, (snapshot) => {
      if (snapshot.exists()) {
        setDoctors(snapshot.val());
      } else {
        setDoctors({});
      }
    });
  }, [adminName1]);

  useEffect(() => {
    const unassigned = Object.keys(posts).filter(
      (id) => !posts[id].DoctorAssigned || posts[id].DoctorAssigned.length === 0
    );
    setUnassignedPatients(unassigned);
  }, [posts]);

  // Viniith Fix this 05-08-2025 - Reset to page 1 when search terms change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerms]);

  // Search Firebase if patient not found in loaded data
  useEffect(() => {
    const hasSearchTerm = searchTerms.fullName.trim() || searchTerms.patientId.trim();
    
    if (hasSearchTerm && filteredPosts.length === 0 && Object.keys(posts).length > 0 && !isSearchingFirebase) {
      // No results found in current data, search Firebase after a small delay
      const timeoutId = setTimeout(() => {
        searchPatientInFirebase(searchTerms.fullName, searchTerms.patientId);
      }, 500); // 500ms delay to avoid searching on every keystroke
      
      return () => clearTimeout(timeoutId);
    }
  }, [searchTerms.fullName, searchTerms.patientId]);

  const handleClearTask = (index) => {
    setAiTasks((prev) => prev.filter((_, i) => i !== index));
  };

  /* Function to handle logout */
  const handleLogout = async () => {
    try {
      await logOut();
      navigate("/");
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleAssignDoctor = async (
    patientId,
    selectedDoctor,
    isAssigned,
    isBulkAssign = false
  ) => {
    try {
      const doctorField = "DoctorAssigned";
      const valuesRef = ref(
        db,
        `superadmin/admins/${adminName1}/patients/${patientId}/${doctorField}`
      );

      // deepa audit: Get patient details for logging
      const patient = posts[patientId];
      const patientName = patient?.FullName || "Unknown";

      // deepa audit: Get previous doctors for logging
      const previousDoctors = patient?.[doctorField] || [];

      if (isAssigned) {
        // Unassign the doctor
        await runTransaction(valuesRef, (currentData) => {
          if (currentData) {
            // Filter out the selected doctor in all entries (for old and new formats)
            const updatedData = currentData.filter((doctor) => {
              if (typeof doctor === "string") {
                return doctor !== selectedDoctor; // Old format
              } else if (doctor && typeof doctor === "object") {
                return doctor.name !== selectedDoctor; // New format
              }
              return true;
            });

            return updatedData.length > 0 ? updatedData : null; // Return null to remove the field if empty
          }
          return null;
        });

        setPosts((prevPosts) => ({
          ...prevPosts,
          [patientId]: {
            ...prevPosts[patientId],
            [doctorField]: (prevPosts[patientId][doctorField] || []).filter(
              (doctor) => {
                // Handle both string and object formats
                if (typeof doctor === "string") {
                  return doctor !== selectedDoctor;
                } else {
                  return doctor.name !== selectedDoctor;
                }
              }
            ),
          },
        }));

        // deepa audit: Log individual unassignment
        if (!isBulkAssign) {
          await logReportReadAssignmentTech({
            assignedBy: techname || "Unknown Technician",
            assignedDoctor: selectedDoctor,
            patientId: patient.ID, // Pass raw ID for encryption in audit log
            patientName: patientName,
            success: true,
            isUnassign: true,
            previousDoctors: previousDoctors,
          });

          toast.success("Doctor Unassigned Successfully", {
            position: "top-center",
          });
        }
      } else {
        // Assign the doctor in the new format
        const assignedAt = formatDate(new Date());

        const doctorWithTimestamp = {
          name: selectedDoctor,
          assignedAt: assignedAt,
        };

        await runTransaction(valuesRef, (currentData) => {
          let updatedData = currentData ? [...currentData] : [];

          // Ensure no duplicate entries by filtering out any existing instance of the selected doctor
          updatedData = updatedData.filter((doctor) => {
            if (typeof doctor === "string") {
              return doctor !== selectedDoctor;
            } else if (doctor && typeof doctor === "object") {
              return doctor.name !== selectedDoctor;
            }
            return true;
          });

          // Add the new doctor with timestamp
          updatedData.push(doctorWithTimestamp);
          return updatedData;
        });

        setPosts((prevPosts) => ({
          ...prevPosts,
          [patientId]: {
            ...prevPosts[patientId],
            [doctorField]: [
              ...(prevPosts[patientId][doctorField] || []),
              doctorWithTimestamp,
            ],
          },
        }));

        // deepa audit: Log individual assignment
        if (!isBulkAssign) {
          await logReportReadAssignmentTech({
            assignedBy: techname || "Unknown Technician",
            assignedDoctor: selectedDoctor,
            patientId: patient.ID, // Pass raw ID for encryption in audit log
            patientName: patientName,
            success: true,
            isUnassign: false,
            previousDoctors: previousDoctors,
          });

          toast.success("Doctor Assigned Successfully", {
            position: "top-center",
          });
        }
      }
      // Close the dropdown after assignment
      setSelectedDropdownId(null);
    } catch (error) {
      // deepa audit: Log failed assignment
      const patient = posts[patientId];
      const patientName = patient?.FullName || "Unknown";

      await logIndividualAssignmentTech({
        assignedBy: techname || "Unknown Technician",
        assignedDoctor: selectedDoctor,
        patientId: patient.ID, // Pass raw ID for encryption in audit log
        patientName: patientName,
        success: false,
        failureReason: error.message || "Unknown error",
        isUnassign: isAssigned,
      });

      alert(
        "Error Assigning Doctor, ask Admin to Delete already assigned doctor if any from the database.",
        error
      );
    }
  };

  const handleBulkAssign = async () => {
    try {
      // deepa audit: Prepare data for bulk assignment logging
      const patientIds = [];
      const patientNames = [];

      // deepa audit: Collect patient details before assignment
      bulkSelectedPatients.forEach((patientId) => {
        const patient = posts[patientId];
        const patientName = patient?.FullName || "Unknown";
        // Use encrypted ID directly from patient data
        const patientIdEncrypted = patient?.ID || patientId;

        patientIds.push(patientIdEncrypted);
        patientNames.push(patientName);
      });

      // deepa audit: Log bulk assignment start
      await logBulkAssignmentTech({
        assignedBy: techname || "Unknown Technician",
        assignedDoctor: bulkSelectedDoctor,
        patientCount: bulkSelectedPatients.length,
        patientIds: patientIds,
        patientNames: patientNames,
        success: true,
        assignmentType: "bulk",
      });

      // Execute bulk assignments
      const assignmentPromises = bulkSelectedPatients.map((patientId) =>
        handleAssignDoctor(patientId, bulkSelectedDoctor, false, true)
      );

      await Promise.all(assignmentPromises);

      toast.success("Doctor assigned successfully!", {
        position: "top-center",
      });

      setBulkAssignModalVisible(false);
      setBulkSelectedPatients([]);
      setBulkSelectedDoctor("");

      // deepa audit logs: Log bulk assignment success
      await logBulkAssignmentTech({
        assignedBy: techname || "Unknown Technician",
        assignedDoctor: bulkSelectedDoctor,
        patientCount: bulkSelectedPatients.length,
        patientIds: bulkSelectedPatients.map((p) => p.ID),
        patientNames: bulkSelectedPatients.map((p) => p.FullName),
        success: true,
      });
    } catch (error) {
      // deepa audit: Log bulk assignment failure
      const patientIds = bulkSelectedPatients.map((patientId) => {
        const patient = posts[patientId];
        // Use encrypted ID directly from patient data
        return patient?.ID || patientId;
      });

      const patientNames = bulkSelectedPatients.map((patientId) => {
        const patient = posts[patientId];
        return patient?.FullName || "Unknown";
      });

      await logBulkAssignmentTech({
        assignedBy: techname || "Unknown Technician",
        assignedDoctor: bulkSelectedDoctor,
        patientCount: bulkSelectedPatients.length,
        patientIds: patientIds,
        patientNames: patientNames,
        success: false,
        failureReason: error.message || "Unknown error during bulk assignment",
        assignmentType: "bulk",
      });

      toast.error("Bulk assignment failed. Please try again.", {
        position: "top-center",
      });
    }
  };

  const handleSearch = (event) => {
    const { name, value } = event.target;
    setSearchTerms((prevSearchTerms) => ({
      ...prevSearchTerms,
      [name]: value,
    }));
  };

  const encryptOld = (data) => {
    return window.btoa(data);
  };

  // deepa log - Audit logging function for share events (May 25, 2024)
  // Logs when technicians share/copy/whatsapp patient reports
  // Stores in audit_logs/UserManagement/Technician_logs/Share_Report_Tec
  const logShareEventTech = async (
    id,
    action = "share",
    success = true,
    failureReason = ""
  ) => {
    try {
      const logRef = ref(
        db,
        "audit_logs/UserManagement/Technician_logs/Share_Report_Tec"
      );
      const technicianName = localStorage.getItem("Name");
      const currentDate = new Date();

      // Get browser and device info for audit trail
      const browser = navigator.userAgent;
      const device = /Mobi|Android/i.test(browser) ? "Mobile" : "Desktop";

      // Get IP and location info for audit trail
      let ip = "Unknown";
      let location = "Unknown";
      try {
        const resp = await fetch("https://ipapi.co/json/");
        const loc = await resp.json();
        ip = loc.ip || "Unknown";
        location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
      } catch (err) {
        console.warn("Failed to fetch IP info:", err);
      }

      // Get patient details for audit log
      const patientRef = ref(
        db,
        `superadmin/admins/${adminName1}/patients/${id}`
      );
      const patientSnapshot = await get(patientRef);
      const patientData = patientSnapshot.val();
      const patientName = patientData?.FullName
        ? decryptDataIfNeeded(patientData.FullName)
        : "";
      const encryptedPatientId = patientData?.ID || "";

      // deepa log - Create audit log entry with required schema
      const logEntry = {
        event_type: `report_share_${action}`,
        technician_name: technicianName,
        patient_id_encrypted: encryptedPatientId,
        patient_name: patientName,
        report_url: selectedLink || "",
        success,
        timestamp: currentDate.toISOString(),
        details: {
          action,
          browser,
          device,
          ip,
          location,
        },
      };

      await push(logRef, logEntry);
      console.log("Share event logged successfully");
    } catch (error) {
      console.error("Failed to log share event:", error);
    }
  };

  // deepa log - Modified to include audit logging for initial share action
  const handleShareClick = (id) => {
    try {
      // Determine the base URL based on the environment
      const baseUrl =
        process.env.NODE_ENV === "development"
          ? "http://localhost:3000"
          : "https://tryon.easiofy.com"; // <-- Updated AWS URL

      // Generate the link using the appropriate base URL
      const generatedLink = `${baseUrl}/patient/${encryptOld(
        adminName1
      )}/${encryptOld(id)}`;

      setSelectedLink(generatedLink);
      setModalVisible(true);

      // deepa log - Log successful share event with database ID
      logShareEventTech(id, "share", true);
    } catch (error) {
      console.error("Error in handleShareClick:", error);
      // deepa log - Log failed share event
      logShareEventTech(id, "share", false, error.message);
    }
  };

  // deepa log - Modified to include audit logging for copy action
  const copyToClipboard = () => {
    try {
      navigator.clipboard.writeText(selectedLink);
      alert("Link copied to clipboard!");
      setModalVisible(false);

      // Extract the database ID from the URL (not the encrypted one)
      const urlParts = selectedLink.split("/");
      const encryptedId = urlParts[urlParts.length - 1];
      const databaseId = decryptOld(encryptedId);

      // deepa log - Log successful copy event with database ID
      logShareEventTech(databaseId, "copy", true);
    } catch (error) {
      console.error("Error copying to clipboard:", error);
      const urlParts = selectedLink.split("/");
      const encryptedId = urlParts[urlParts.length - 1];
      const databaseId = decryptOld(encryptedId);
      // deepa log - Log failed copy event
      logShareEventTech(databaseId, "copy", false, error.message);
    }
  };

  // deepa log - Modified to include audit logging for WhatsApp share
  const shareViaWhatsApp = () => {
    try {
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
        "Click this link to View your Data: " + selectedLink
      )}`;
      window.open(whatsappUrl, "_blank");
      setModalVisible(false);

      // Extract the database ID from the URL (not the encrypted one)
      const urlParts = selectedLink.split("/");
      const encryptedId = urlParts[urlParts.length - 1];
      const databaseId = decryptOld(encryptedId);

      // deepa log - Log successful WhatsApp share event with database ID
      logShareEventTech(databaseId, "whatsapp", true);
    } catch (error) {
      console.error("Error sharing via WhatsApp:", error);
      const urlParts = selectedLink.split("/");
      const encryptedId = urlParts[urlParts.length - 1];
      const databaseId = decryptOld(encryptedId);
      // deepa log - Log failed WhatsApp share event
      logShareEventTech(databaseId, "whatsapp", false, error.message);
    }
  };

  const getLatestModality = (patient) => {
    if (!patient) return "N/A";

    let modalityValue = "N/A";
    if (patient.Version === "03" && patient.uploads) {
      const scanKeys = Object.keys(patient.uploads)
        .filter((key) => key.toLowerCase().startsWith("scan"))
        .map((key) => ({
          key,
          number: parseInt(key.replace("Scan", "").trim(), 10),
        }))
        .sort((a, b) => b.number - a.number);

      for (const { key } of scanKeys) {
        const scan = patient.uploads[key];
        if (
          scan.Modality &&
          typeof scan.Modality === "string" &&
          scan.Modality.trim() !== ""
        ) {
          modalityValue = scan.Modality.trim();
          break;
        }
      }
    }
    if (modalityValue === "N/A" && patient.Modality) {
      if (Array.isArray(patient.Modality)) {
        modalityValue =
          patient.Modality.length > 0 ? patient.Modality[0] : "N/A";
      } else if (typeof patient.Modality === "string") {
        modalityValue = patient.Modality;
      }
    }
    return modalityValue;
  };

  // Helper function to get AI classification from patient data
  const getAIClassification = (patient) => {
    try {
      // Check if modality is XRAY-related first
      const modality = (getLatestModality(patient) || "").toLowerCase();
      const isXrayModality =
        modality.includes("xr") ||
        modality.includes("x ray") ||
        modality.includes("x-ray") ||
        modality.includes("xray");

      // Only process XRAY modality, others show "-"
      if (!isXrayModality) {
        return "-";
      }

      // Check if AI has been run (AI_result flag exists and is true)
      const aiHasRun = patient.AI_result === true;

      // If AI hasn't been run, show "-"
      if (!aiHasRun) {
        return "-";
      }

      // AI has been run, now check for AI_Report
      // Check if patient has Version 03 with uploads structure
      if (patient.Version === "03" && patient.uploads) {
        // Find the latest scan
        const scanKeys = Object.keys(patient.uploads)
          .filter((key) => key.toLowerCase().includes("scan"))
          .map((key) => ({
            key,
            number: parseInt(key.replace(/\D/g, "")) || 0,
          }))
          .sort((a, b) => b.number - a.number);

        if (scanKeys.length > 0) {
          const latestScanKey = scanKeys[0].key;
          const latestScan = patient.uploads[latestScanKey];

          // Check if AI_Report exists in the latest scan
          if (
            latestScan &&
            latestScan.AI_Report &&
            latestScan.AI_Report.classification
          ) {
            return latestScan.AI_Report.classification;
          }
        }
      } else {
        // For legacy patients, check AI_Report at patient level
        if (patient.AI_Report && patient.AI_Report.classification) {
          return patient.AI_Report.classification;
        }
      }

      // AI has run but no AI_Report found
      return "NA";
    } catch (error) {
      console.error("Error getting AI classification:", error);
      return "NA";
    }
  };

  // dicom folder
  const handleScan = async (patient) => {
    try {
      let decryptedFolderPath = null;

      if (patient.Version === "03" && patient.uploads) {
      //  console.log("Handling Version '03' with nested uploads.");

        const uploads = patient.uploads;

        // Validate uploads
        if (!uploads || Object.keys(uploads).length === 0) {
          console.error("Uploads data is missing or empty:", uploads);
          alert("No uploads available for this patient.");
          return;
        }

        // Sort scan keys numerically (e.g., Scan 1, Scan 2)
        const scanKeys = Object.keys(uploads).sort((a, b) => {
          const numA = parseInt(a.replace("Scan ", ""), 10);
          const numB = parseInt(b.replace("Scan ", ""), 10);
          return numB - numA; // Latest scan first
        });

        // Iterate through scans to find the latest valid FolderPath
        for (const scanKey of scanKeys) {
          const scan = uploads[scanKey];
          if (scan && scan.FolderPath && scan.FolderPath !== "NA") {
            decryptedFolderPath = decryptDataIfNeeded(scan.FolderPath);
            break; // Stop after finding the latest valid FolderPath
          }
        }

        if (!decryptedFolderPath) {
          console.error("No valid FolderPath found in any scan:", uploads);
          alert("FolderPath is missing for all scans.");
          return;
        }
      } else if (patient.FolderPath && patient.FolderPath !== "NA") {
   
        decryptedFolderPath = decryptDataIfNeeded(patient.FolderPath);
    
      } else {
        console.error(
          "FolderPath missing for earlier version patient:",
          patient
        );
        alert("FolderPath is not available for this patient.");
        return;
      }

      if (!decryptedFolderPath || decryptedFolderPath === "NA") {
        console.error("FolderPath is missing or decryption failed:", patient);
        alert("FolderPath decryption failed or not available.");
        return;
      }

      // Open the FolderPath in the viewer
      //const viewerURL = `https://easiofydicomviewer.netlify.app/?Patient=${encodeURIComponent(
      const viewerURL = ` https://tryon.easiofy.com/DWV/?Patient=${encodeURIComponent(
        decryptedFolderPath
      )}&View=Technician`;
     // console.log("Opening Viewer URL:", viewerURL);
      window.open(viewerURL, "_blank");
      // deepa auditlogs: Log technician DICOM view event
      await logViewDicomTechnician({
        technicianName: techname || "UnknownTechnician",
        patientId: patient.ID,
        patientName: patient.FullName,
        dicomUrl: viewerURL,
        success: true,
      });
    } catch (error) {
      console.error("Error handling scan:", error);
      alert("An unexpected error occurred while handling the scan.");
      // deepa auditlogs: Log failure event
      await logViewDicomTechnician({
        technicianName: techname || "UnknownTechnician",
        patientId: patient.ID,
        patientName: patient.FullName,
        dicomUrl: "",
        success: false,
        failureReason: error.message || "Unknown error",
      });
    }
  };

  // REMOVED: This was fetching ALL patients and overriding orderByChild query
  // The fetchPatientKeys() function now handles fetching with orderByChild
  /*
  useEffect(() => {
    const postsRef = ref(db, `superadmin/admins/${adminName1}/patients`);
    onValue(postsRef, (snapshot) => {
      const data = snapshot.val();
      const decryptedData = {};

      Object.keys(data || {}).forEach((id) => {
        const patient = data[id];
        // deepa fix issue patient delete - Skip null entries that may remain after a patient is deleted
        if (!patient) {
          return; // continue to next id
        }
        const version = patient.Version || "1"; // Default to Version 1 if not specified

        // Normalize DoctorAssigned field for all versions and filter out invalid entries
        let DoctorAssigned = patient.DoctorAssigned;
        if (DoctorAssigned) {
          if (Array.isArray(DoctorAssigned)) {
            DoctorAssigned = DoctorAssigned.map((doctor) => {
              if (typeof doctor === "string") {
                const cleanName = doctor.trim().toLowerCase();
                // Filter out invalid doctor names
                if (
                  cleanName === "" ||
                  cleanName === "doctor common" ||
                  cleanName === "doctorcommon" ||
                  cleanName === "null" ||
                  cleanName === "undefined"
                ) {
                  return null; // Remove invalid entries
                }
                return { name: doctor }; // Convert valid string to object
              } else if (
                typeof doctor === "object" &&
                doctor !== null &&
                doctor.name
              ) {
                const cleanName = doctor.name.trim().toLowerCase();
                // Filter out invalid doctor names in objects
                if (
                  cleanName === "" ||
                  cleanName === "doctor common" ||
                  cleanName === "doctorcommon" ||
                  cleanName === "null" ||
                  cleanName === "undefined"
                ) {
                  return null; // Remove invalid entries
                }
                return doctor; // Keep valid object as is
              } else {
                return null; // Remove invalid entries
              }
            }).filter((doctor) => doctor !== null);
          } else {
            DoctorAssigned = [];
          }
        } else {
          DoctorAssigned = [];
        }

        if (version === "03" || version === "3") {
          // Handle Version 3 - Show only one row per patient with latest scan data
          const uploads = patient.uploads || {};

          // Get the latest scan (highest scan number)
          const scanKeys = Object.keys(uploads)
            .filter((key) => key.toLowerCase().startsWith("scan"))
            .map((key) => ({
              key,
              number: parseInt(key.replace(/\D/g, ""), 10) || 0,
            }))
            .sort((a, b) => b.number - a.number); // Sort by scan number, descending (latest first)

          // Use the latest scan data if available
          let latestScanData = {};
          if (scanKeys.length > 0) {
            const latestScanKey = scanKeys[0].key;
            latestScanData = uploads[latestScanKey];
          }
          // PRIORITY LOGIC FOR Dicom_ReportURL:
          // 1. Check all scans (latest first) for valid Dicom_ReportURL
          // 2. If not found in any scan, fallback to main patient node
          let foundReportURL = "";

          // Priority 1: Check uploads/scans for Dicom_ReportURL (latest first)
          for (const { key } of scanKeys) {
            const upload = uploads[key];
            // Check for encrypted Dicom_ReportURL first, then plain text
            const reportURL =
              getPatientData(upload, "Dicom_ReportURL") ||
              upload.Dicom_ReportURL;
            const validReportURL = getValidString(reportURL);

            if (validReportURL) {
              foundReportURL = reportURL;
              break; // Use the first valid report found (from latest scan)
            }
          }

          // Priority 2: Fallback to main patient node if not found in any scan
          if (!foundReportURL) {
            const mainReportURL =
              getPatientData(patient, "Dicom_ReportURL") ||
              patient.Dicom_ReportURL;
            const validMainReportURL = getValidString(mainReportURL);

            if (validMainReportURL) {
              foundReportURL = mainReportURL;

            }
          }

          // Create single entry for this patient with latest scan data
          decryptedData[id] = {
            id,
            version: "03",
            ...patient,
            FullName: decryptDataIfNeeded(patient.FullName),
            Age: decryptDataIfNeeded(patient.Age),
            Gender: decryptDataIfNeeded(patient.Gender),
            ID: decryptDataIfNeeded(patient.ID),
            DoctorAssigned: DoctorAssigned,
            Dicom_3D: latestScanData.Dicom_3D || "NA",
            Dicom_3DURL: decryptDataIfNeeded(latestScanData.Dicom_3DURL),
            Dicom_Report: latestScanData.Dicom_Report || "NA",
            Dicom_ReportURL: foundReportURL
              ? decryptDataIfNeeded(foundReportURL)
              : "NA",
            FolderPath: decryptDataIfNeeded(latestScanData.FolderPath) || "NA",
            Modality: latestScanData.Modality || "NA",
            StudyDate: latestScanData.StudyDate || "NA",
            PrescriptionURL:
              decryptDataIfNeeded(latestScanData.PrescriptionURL) || "NA",
          };
        } else {
          // Handle Versions 1 and 2 (Old Formats)
          decryptedData[id] = {
            id,
            version,
            ...patient,
            FullName: decryptDataIfNeeded(patient.FullName),
            Age: decryptDataIfNeeded(patient.Age),
            Gender: decryptDataIfNeeded(patient.Gender),
            ID: decryptDataIfNeeded(patient.ID),
            DoctorAssigned: DoctorAssigned, // Use the normalized DoctorAssigned
            Modality: decryptDataIfNeeded(patient.Modality) || "NA",
            StudyDate: decryptDataIfNeeded(patient.StudyDate) || "NA",
            Dicom_3D: decryptDataIfNeeded(patient.Dicom_3D) || "NA",
            Dicom_3DURL: decryptDataIfNeeded(patient.Dicom_3DURL) || "NA",
            Dicom_Report: decryptDataIfNeeded(patient.Dicom_Report) || "NA",
            Dicom_ReportURL:
              decryptDataIfNeeded(patient.Dicom_ReportURL) || "NA",
            FolderPath: decryptDataIfNeeded(patient.FolderPath) || "NA", // Ensure FolderPath is handled
            // Decrypt the top-level PrescriptionURL for older versions
            PrescriptionURL:
              decryptDataIfNeeded(patient.PrescriptionURL) || "NA",
          };
        }
      });

      // Sort by Timestamp (latest first)
      const sortedData = Object.keys(decryptedData)
        .sort((a, b) => {
          const dateA = new Date(
            decryptedData[a].Timestamp || "1970-01-01T00:00:00"
          );
          const dateB = new Date(
            decryptedData[b].Timestamp || "1970-01-01T00:00:00"
          );
          return dateB - dateA; // Descending order: latest first
        })
        .reduce((acc, id) => {
          acc[id] = decryptedData[id];
          return acc;
        }, {});

      // Set the sorted data to posts
      setPosts(sortedData);
    });
  }, [adminName1]);
  */

  // Helper function to check if the patient has a valid DICOM folder
  const hasDicomFolder = (patient) => {
    let folderPath;
    if (patient.Version === "03" && patient.uploads) {
      const scanKeys = Object.keys(patient.uploads)
        .filter((key) => key.startsWith("Scan"))
        .map((key) => ({
          key,
          number: parseInt(key.replace("Scan ", ""), 10),
        }))
        .sort((a, b) => b.number - a.number); // Latest scan first

      for (const { key } of scanKeys) {
        const scan = patient.uploads[key];
        if (scan && scan.FolderPath && scan.FolderPath !== "NA") {
          folderPath = decryptDataIfNeeded(scan.FolderPath);
          break;
        }
      }
    } else if (patient.FolderPath && patient.FolderPath !== "NA") {
      folderPath = decryptDataIfNeeded(patient.FolderPath);
    }
    return Boolean(folderPath);
  };

  // Report

  const handleReport = async (patient, action = "view") => {
    let reportURL = null;
    let success = true;
    let failureReason = "";

    try {
      // Get raw patient ID for audit log
      const patientId = patient.ID;

      let foundReportURL = "";
      let reportSource = "";
      // PRIORITY 1: Find report in uploads (Version 03 patients) - Check LATEST scan first
      if (patient.Version === "03" && patient.uploads) {
        const scanKeys = Object.keys(patient.uploads)
          .filter((key) => key.toLowerCase().includes("scan"))
          .map((key) => ({
            key,
            number: parseInt(key.replace(/\D/g, "")) || 0, // Extract number from scan key
          }))
          .sort((a, b) => b.number - a.number); // Sort by highest number first (latest scan)

 

        for (const { key } of scanKeys) {
          const upload = patient.uploads[key];
          // Check for encrypted Dicom_ReportURL in uploads first, then plain text
          const reportURLCandidate =
            getPatientData(upload, "Dicom_ReportURL") || upload.Dicom_ReportURL;
          const validReportURL = getValidString(reportURLCandidate);
          if (validReportURL) {
            foundReportURL = validReportURL;
            reportSource = `Latest Upload (${key})`;
            break; // Use the latest scan's report
          }
        }
      }

      // PRIORITY 2: Fallback to main patient node for report (both Version 03 and legacy)
      if (!foundReportURL) {
        // Try encrypted field first, then plain text field
        const mainReportURLCandidate =
          getPatientData(patient, "Dicom_ReportURL") || patient.Dicom_ReportURL;
        const validReportURL = getValidString(mainReportURLCandidate);
        if (validReportURL) {
          foundReportURL = validReportURL;
          reportSource = "Main Patient Node";
        }
      }

      // PRIORITY 3: No report found anywhere
      if (!foundReportURL) {
        reportSource = "Not Available";
      }
      reportURL = foundReportURL;

      // Decrypt the report URL
      const decryptedURL = decrypt(reportURL);

      if (!decryptedURL || decryptedURL === "NA") {
        toast.info("Report not available", {
          position: "top-center",
        });
        success = false;
        failureReason = "Report not available";

        // deepa audit logs: Log failed attempt based on action type
        if (action === "view") {
          await logReportReadTech({
            technicianName: techname || adminName1,
            patientId,
            patientName: patient.FullName,
            action,
            reportUrl: "NA",
            success: false,
            failureReason: "Report not available",
          });
        } else {
          await logReportDownloadTech({
            technicianName: techname || adminName1,
            patientId,
            patientName: patient.FullName,
            reportUrl: "NA",
            success: false,
            failureReason: "Report not available",
          });
        }
        return;
      }

      if (action === "view") {
        // deepa audit logs: Log view event
        await logReportReadTech({
          technicianName: techname || adminName1,
          patientId,
          patientName: patient.FullName,
          action: "view",
          reportUrl: reportURL,
          success: true,
        });

        // Then open the report in a new tab
        window.open(decryptedURL, "_blank");
      } else if (action === "download") {
        try {
          const response = await fetch(decryptedURL);
          if (!response.ok) {
            throw new Error("Failed to fetch file.");
          }
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `${patient.FullName || "Patient"}_Report.pdf`;

          // deepa audit logs: Log successful download event
          await logReportDownloadTech({
            technicianName: techname || adminName1,
            patientId,
            patientName: patient.FullName,
            reportUrl: reportURL,
            success: true,
          });

          // Then trigger the download
          link.click();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Error downloading report:", error);
          toast.error("Failed to download the report. Please try again.", {
            position: "top-center",
          });

          // deepa audit logs: Log failed download
          await logReportDownloadTech({
            technicianName: techname || adminName1,
            patientId,
            patientName: patient.FullName,
            reportUrl: reportURL,
            success: false,
            failureReason: error.message,
          });
        }
      }
    } catch (error) {
      console.error("Error handling report:", error);
      toast.error("Error handling report. Please try again.", {
        position: "top-center",
      });

      // deepa audit logs: Log error based on action type
      if (action === "view") {
        await logReportReadTech({
          technicianName: techname || adminName1,
          patientId: patient.ID,
          patientName: patient.FullName,
          action,
          reportUrl: reportURL || "NA",
          success: false,
          failureReason: error.message,
        });
      } else {
        await logReportDownloadTech({
          technicianName: techname || adminName1,
          patientId: patient.ID,
          patientName: patient.FullName,
          reportUrl: reportURL || "NA",
          success: false,
          failureReason: error.message,
        });
      }
    }
  };

  // Search Firebase for specific patient by Name or ID
  const searchPatientInFirebase = async (searchName, searchId) => {
    if (!adminName1 || (!searchName && !searchId) || isSearchingFirebase) return;
    
    setIsSearchingFirebase(true);
    
    try {
      const patientsRef = ref(db, `superadmin/admins/${adminName1}/patients`);
      const snapshot = await get(patientsRef);
      const allPatients = snapshot.val();
      
      if (!allPatients) {
        setIsSearchingFirebase(false);
        return;
      }
      
      const foundPatients = {};
      Object.keys(allPatients).forEach((patientId) => {
        const patient = allPatients[patientId];
        const decryptedName = decryptDataIfNeeded(patient.FullName);
        const decryptedId = decryptDataIfNeeded(patient.ID);
        
        const matchesName = searchName ? decryptedName.toLowerCase().includes(searchName.toLowerCase().trim()) : true;
        const matchesId = searchId ? decryptedId.toLowerCase().includes(searchId.toLowerCase().trim()) : true;
        
        if (matchesName && matchesId) {
          const processed = processPatientData(patientId, patient);
          if (processed) {
            foundPatients[patientId] = processed;
          }
        }
      });
      
      // Add found patients to posts if not already present
      if (Object.keys(foundPatients).length > 0) {
        setPosts(prev => ({ ...prev, ...foundPatients }));
      } else {
        toast.info("No matching patients found", {
          position: "top-center",
          autoClose: 2000
        });
      }
    } catch (error) {
      console.error("Error searching patient in Firebase:", error);
      toast.error("Error searching database", {
        position: "top-center"
      });
    } finally {
      setIsSearchingFirebase(false);
    }
  };

  const filteredPosts = useMemo(() => {
    return Object.keys(posts || {}).filter((id) => {
      const patient = posts[id];
      const fullName = (patient?.FullName || "").toLowerCase().trim();
      const patientId = (patient?.ID || "").toLowerCase().trim();
      const centerName = (patient?.Addedby || "").toLowerCase().trim();
      const status = (patient?.Report_Status || "").toLowerCase().trim();

      let latestModality = null; // Default to null instead of "NA"

      if (patient?.uploads && patient.Version === "03") {
        // Get the latest scan (highest scan number)
        const scanKeys = Object.keys(patient.uploads)
          .filter((key) => key.toLowerCase().startsWith("scan"))
          .map((key) => ({
            key,
            number: parseInt(key.replace("Scan", "").trim(), 10),
            modality: patient.uploads[key].Modality || null, // Ensure it's fetched
          }))
          .sort((a, b) => b.number - a.number); // Sort scans by latest first

        // Iterate to find the first valid modality
        for (const scan of scanKeys) {
          if (scan.modality) {
            latestModality = scan.modality.toUpperCase().trim();
            break; // Stop when a valid modality is found
          }
        }
      } else {
        // Handle older versions
        latestModality = patient.Modality
          ? patient.Modality.toUpperCase().trim()
          : null;
      }

      // If modality is missing, set it to "NA"
      if (!latestModality) {
        latestModality = "NA";
      }

      // **STRICT MATCH: Ensure only X-RAY results appear**
      const matchesModality =
        searchTerms.modality === "" || // Show all if no filter is selected
        latestModality === searchTerms.modality.toUpperCase(); // Exact match

      return (
        matchesModality && // ✅ Strict Modality Filtering
        fullName.includes(searchTerms.fullName.toLowerCase().trim()) &&
        patientId.includes(searchTerms.patientId.toLowerCase().trim()) &&
        (searchTerms.centerName === "" ||
          centerName === searchTerms.centerName.toLowerCase().trim()) &&
        (searchTerms.status === "" ||
          status === searchTerms.status.toLowerCase().trim())
      );
    });
  }, [posts, searchTerms]);

  const indexOfLastPatient = currentPage * patientsPerPage;
  const indexOfFirstPatient = indexOfLastPatient - patientsPerPage;

  const parseTimestamp = (timestamp) => {
    if (!timestamp) return new Date(0);
    
    // Try parsing as ISO format first (YYYY-MM-DDTHH:mm:ss.sssZ)
    const isoDate = new Date(timestamp);
    if (!isNaN(isoDate.getTime())) {
      return isoDate; // Valid ISO format
    }
    
    // Fallback: Try parsing old format (dd/mm/yyyy, hh:mm:ss)
    if (timestamp.includes(",")) {
      const [datePart, timePart] = timestamp.split(", ");
      const [day, month, year] = datePart.split("/").map(Number);
      const [hours = 0, minutes = 0, seconds = 0] = timePart
        ? timePart.split(":").map(Number)
        : [0, 0, 0];
      return new Date(year, month - 1, day, hours, minutes, seconds);
    }
    
    return new Date(0); // Invalid format
  };

  // Format timestamp for display (converts ISO to dd/mm/yyyy, hh:mm:ss)
  const formatTimestampForDisplay = (timestamp) => {
    if (!timestamp) return "NA";
    
    // If already in old format (contains comma), return as-is
    if (timestamp.includes(", ")) {
      return timestamp;
    }
    
    // Parse ISO format and convert to readable format
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return timestamp; // Return original if invalid
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
  };

  // Helper function to get the most recent StudyDate from uploads
  const getLatestStudyDateFromUploads = (uploads) => {
    if (!uploads) return null; // Return null if no uploads

    // Iterate through uploads to find the most recent StudyDate
    const latestStudyDate = Object.keys(uploads).reduce((latestDate, key) => {
      const scan = uploads[key];
      if (scan.StudyDate) {
        const scanDate = new Date(
          scan.StudyDate.split("/").reverse().join("-")
        );
        return scanDate > latestDate ? scanDate : latestDate; // Keep the latest date
      }
      return latestDate;
    }, new Date(0));

    return latestStudyDate > new Date(0) ? latestStudyDate : null; // Return null if no valid dates
  };

  // Sort by Received time (Timestamp) - latest first
  const getSortingDate = (patient) => {
    if (!patient) return new Date(0); // fallback
    const timestampDate = parseTimestamp(patient.Timestamp); // Parse Timestamp (Received time)
    return timestampDate; // Sort by Received time only
  };

  // Sorting Logic
  const sortedFilteredPosts = filteredPosts.sort((a, b) => {
    const sortingDateA = getSortingDate(posts[a]); // Get sorting date for post A
    const sortingDateB = getSortingDate(posts[b]); // Get sorting date for post B

    return sortingDateB - sortingDateA; // Descending order: latest first
  });

  // Slice the sorted list for pagination
  const currentPatients = sortedFilteredPosts.slice(
    indexOfFirstPatient,
    indexOfLastPatient
  );

  const paginate = async (pageNumber) => {
    const currentTotalPages = Math.ceil(filteredPosts.length / patientsPerPage);
    
    // If user is trying to go beyond current loaded pages and more patients exist
    if (pageNumber > currentTotalPages && hasMorePatients && !isLoadingBatch) {
      await loadMorePatients();
      // After loading, set to the first page of newly loaded data
      setCurrentPage(pageNumber);
    } else {
      setCurrentPage(pageNumber);
    }
  };

  // Calculate total pages, always add 1 extra if more patients can be loaded
  const totalPages = hasMorePatients 
    ? Math.ceil(filteredPosts.length / patientsPerPage) + 1 
    : Math.ceil(filteredPosts.length / patientsPerPage);

  function getMonthYearLabel() {
    const date = new Date();
    const monthNames = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${month} ${year}`;
  }

  // Inside your pollStatus function...

  useEffect(() => {
    return () => {
      Object.values(intervalsRef.current).forEach(clearInterval);
    };
  }, []);

  // =================
  //  AI Logic Start
  // =================

  const updateAiTask = (patientId, updates) => {
    setAiTasks((prev) => {
      const existingIndex = prev.findIndex((t) => t.patientId === patientId);
      if (existingIndex >= 0) {
        const newArr = [...prev];
        newArr[existingIndex] = { ...newArr[existingIndex], ...updates };
        return newArr;
      } else {
        return [...prev, { patientId, ...updates }];
      }
    });
  };

  // ============================
  // New AI Architecture Helpers
  // ============================

  // Common function to store postpaid AI usage
  const storePostpaidAIUsage = async (
    modelName,
    costValue,
    runBy,
    patientName,
    patientID
  ) => {
    // Only exclude Prepaid costing type, log for all others (Cost Per Upload, Cost Per View, Cost Per Upload + View)
    if (costingType && costingType.toLowerCase() === "prepaid") {
      return;
    }

    try {
      const now = new Date();
      const months = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];
      const currentMonth = months[now.getMonth()];
      const currentYear = now.getFullYear();
      const currentMonthYear = `${currentMonth} ${currentYear}`;

      // Format timestamp as requested: 03/03/2025, 01:05:47 PM
      const timestamp = now.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });

      // Get the postpaid path for current month
      const postpaidPath = `superadmin/admins/${adminName1}/Postpaid/${currentMonthYear}`;
      const postpaidRef = ref(db, postpaidPath);

      // Get existing entries to determine the next index
      const snapshot = await get(postpaidRef);
      const nextIndex = snapshot.exists()
        ? Object.keys(snapshot.val()).length
        : 0;

      // Create the usage details
      const usageDetails = {
        AIModelName: modelName,
        Price: costValue,
        RunBy: runBy,
        PatientName: encrypt(patientName),
        PatientID: encrypt(patientID),
        Timestamp: timestamp,
      };

      // Store under the next available index
      const usageRef = ref(db, `${postpaidPath}/${nextIndex}`);
      await set(usageRef, usageDetails);

      console.log(
        `Postpaid AI usage stored: ${modelName} by ${runBy} for patient ${patientName} (${patientID})`
      );
    } catch (error) {
      console.error("Error storing postpaid AI usage:", error);
    }
  };

  // If we do a Prepaid flow, we might deduct from wallet
  const handleWalletDeduction = async (costKey, patient, triggeredByUser) => {
    if (!costKey) return; // No cost? No deduction
    let costValue = 0;
    if (costKey === "CXR-TB") {
      costValue = tbModelCost;
    } else if (costKey === "CXR-TB2") {
      costValue = cxrTb2Cost;
    } else if (costKey === "CXR-Multiclass") {
      costValue = cxrMulticlassCost;
    } else if (costKey === "XRay-Fracture") {
      costValue = boneFractureCost;
    } else if (costKey === "3D-Abdomen") {
      costValue = threeDAbdomenCost;
    } else if (costKey === "Tumor-Abdomen") {
      costValue = tumorAbdomenCost;
    } else if (costKey === "Contour-Abdomen") {
      costValue = contouringModelCost;
    } else if (costKey === "Contour-HaN") {
      costValue = contourHaNModelCost;
    } else {
      costValue = 0; // fallback
    }

    // Check cost
    if (costingType.toLowerCase() === "prepaid") {
      if (walletBalance < costValue) {
        throw new Error("Insufficient funds");
      }
    }

    // If we get here, we either have enough funds (prepaid) or we are postpaid
    // Deduct if it's Prepaid
    if (costingType.toLowerCase() === "prepaid" && costValue > 0) {
      const walletRef = ref(
        db,
        `superadmin/admins/${adminName1}/Wallet/Wallet_Balance`
      );
      const { snapshot } = await runTransaction(walletRef, (currentBalance) => {
        if (currentBalance === null) return 0;
        return currentBalance - costValue;
      });
      const updatedBalance = snapshot.val() || 0;
      setWalletBalance(updatedBalance);

      // Store transaction
      const currentMonthYear = getMonthYearLabel();
      const walletTxPath = `superadmin/admins/${adminName1}/Wallet/Wallet_Transactions/${currentMonthYear}`;
      const txSnapshot = await get(ref(db, walletTxPath));
      const nextIndex = txSnapshot.exists()
        ? Object.keys(txSnapshot.val()).length
        : 0;

      const transaction = {
        ModelRunby: techname,
        PatientName: patient.FullName || "Unknown",
        PatientID: patient.ID || "Unknown",
        AIModel: costKey, // e.g. "boneFractureCost" or "contouringModelCost"
        AmountDeducted: costValue,
        UpdatedBalance: updatedBalance,
        Timestamp: new Date().toLocaleString("en-GB"),
      };
      await set(ref(db, `${walletTxPath}/${nextIndex}`), transaction);
    }
  };

  // If we want to store "AI_result" or set FolderPath, do it here:
  const markAIResult = async (patientId, newFolderPath = null) => {
    // 1) Mark /AI_result = true
    const aiResultRef = ref(
      db,
      `superadmin/admins/${adminName1}/patients/${patientId}/AI_result`
    );
    await set(aiResultRef, true);

    // 2) Optionally update the FolderPath if "newFolderPath" is provided
    if (newFolderPath) {
      const encryptedFolderPath = encrypt(newFolderPath);
      const folderPathRef = ref(
        db,
        `superadmin/admins/${adminName1}/patients/${patientId}/FolderPath`
      );
      await set(folderPathRef, encryptedFolderPath);
    }
  };

  // A function that, given the model ID (and sub-model), executes the pipeline
  async function executeAIModel({
    patientId,
    modelId,
    subModelId = null,
    modelDisplayName,
  }) {
    const patient = posts[patientId];
    if (!patient) {
      toast.error("Patient data not found", { position: "top-center" });
      return;
    }
    // If already run, skip
    if (patient.AI_result) {
      updateAiTask(patientId, { status: "Already done" });
      toast.info(`AI already run for this patient`, { position: "top-center" });
      return;
    }

    // Determine the cost based on which model was selected
    let costValue = 0;
    if (modelId === "XRAY_FRACTURE") {
      costValue = boneFractureCost;
    } else if (modelId === "CONTOUR_ABDOMEN") {
      costValue = contouringModelCost;
    } else if (modelId === "CXR_TB") {
      costValue = tbModelCost;
    } else if (modelId === "3D_ABDOMEN") {
      costValue = threeDAbdomenCost;
    } else if (modelId === "TUMOR_ABDOMEN") {
      costValue = tumorAbdomenCost;
    } else if (modelId === "CXR_MULTICLASS") {
      costValue = cxrMulticlassCost;
    } else if (modelId === "CXR_TB2") {
      costValue = cxrTb2Cost;
    } else if (modelId === "LIVER_SEGMENTATION") {
      costValue = liverSegmentationCost;
    } else if (modelId === "Contour-HaN") {
      costValue = contourHaNModelCost;
    }

    // Add prepaid validation logic (similar to AssignDoctor and DocPanel)
    if (
      costingType &&
      costingType.toLowerCase() === "prepaid" &&
      costValue > 0 &&
      walletBalance < costValue
    ) {
      // Show insufficient balance toast
      toast.error(
        `Not enough balance to run ${
          modelDisplayName || modelId
        }. Required: ${costValue}, Available: ${walletBalance}`,
        {
          position: "top-center",
        }
      );
      updateAiTask(patientId, { status: "Insufficient funds" });
      return;
    }

    // 1) Create the AIModelHandler
    const aiHandler = new AIModelHandler({
      modelId,
      subModelId,
      adminName: adminName1,
      updateTask: (pid, obj) => updateAiTask(pid, obj),
      handleWalletDeduction,
      markAIResult: async (pid, folderPath) => {
        await markAIResult(pid, folderPath);
      },
      getDecryptedFolderPath: (pat) => {
        let folderPath = "";
        if (pat.Version === "03" && pat.uploads) {
          const scanKeys = Object.keys(pat.uploads)
            .filter((key) => key.toLowerCase().startsWith("scan"))
            .map((key) => ({
              key,
              number: parseInt(key.replace("Scan", "").trim(), 10),
            }))
            .sort((a, b) => b.number - a.number);

          for (const { key } of scanKeys) {
            const scanData = pat.uploads[key];
            if (
              scanData &&
              scanData.FolderPath &&
              scanData.FolderPath !== "NA"
            ) {
              folderPath = decryptDataIfNeeded(scanData.FolderPath);
              break;
            }
          }
        } else {
          folderPath = decryptDataIfNeeded(pat.FolderPath);
        }
        return folderPath;
      },
      toast,
      costingType,
      handleWalletDeduction,
      triggeredByUser: techname,
    });

    // 2) Try running the pipeline, passing cost info
    try {
      updateAiTask(patientId, {
        status: "Starting",
        model: modelId,
        subModel: subModelId,
      });
      setAiProcessingModalOpen(true);

      await aiHandler.runModel(patientId, patient, {
        costValue,
        walletBalance,
        costingType,
      });

      // Log usage for all costing types except Prepaid (AFTER successful execution)
      if (costingType && costingType.toLowerCase() !== "prepaid") {
        await storePostpaidAIUsage(
          modelDisplayName || modelId,
          costValue,
          techname,
          patient.FullName || "Unknown",
          patient.ID || "Unknown",
          "Done"
        );
      }

      //deepaaudit logs: log AI model run success
      await logAIModelRunTechnician({
        technicianName: techname || "UnknownTechnician",
        patientId,
        patientName: patient.FullName,
        modelId,
        modelDisplayName,
        subModelId,
        success: true,
      });
    } catch (err) {
      console.error(`${modelDisplayName} model error:`, err);

      // Log failed usage for all costing types except Prepaid
      if (costingType && costingType.toLowerCase() !== "prepaid") {
        await storePostpaidAIUsage(
          modelDisplayName || modelId,
          0,
          techname,
          patient.FullName || "Unknown",
          patient.ID || "Unknown",
          "Fail"
        );
      }

      //deepaaudit logs: log AI model run failure
      await logAIModelRunTechnician({
        technicianName: techname || "UnknownTechnician",
        patientId,
        patientName: patient.FullName,
        modelId,
        modelDisplayName,
        subModelId,
        success: false,
      });

      if (err.message && err.message.includes("Insufficient funds")) {
        updateAiTask(patientId, { status: "Insufficient funds" });
        toast.error(
          `Not enough balance to run ${modelDisplayName || modelId}`,
          {
            position: "top-center",
          }
        );
      } else {
        updateAiTask(patientId, { status: "Failed" });
        toast.error(`${modelDisplayName} model failed`, {
          position: "top-center",
        });
      }
    }
  }

  const handleAI = (patientId) => {
    setAiModalPatientId(patientId);
    setAiModalVisible(true);
  };

  const confirmBoneFracture = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run XRay-Fracture on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "XRAY_FRACTURE",
        modelDisplayName: "XRay-Fracture",
      });
    }
  };

  const confirmContouringAbdomen = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run Contour-Abdomen on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "CONTOUR_ABDOMEN",
        modelDisplayName: "Contour-Abdomen",
      });
    }
  };
  const confirmAbdomenTumorAnalysis = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run Tumor-Abdomen on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "TUMOR_ABDOMEN",
        modelDisplayName: "Tumor-Abdomen",
      });
    }
  };

  const confirmTBDetection = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run CXR-TB on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "CXR_TB",
        modelDisplayName: "CXR-TB",
      });
    }
  };

  const confirmTB2Detection = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run CXR-TB2 Detection on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "CXR_TB2",
        modelDisplayName: "CXR-TB2",
      });
    }
  };

  // ── New "CXR-Multiclass" stub ──
  const confirmCxrMulticlass = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run CXR-Multiclass on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "CXR_MULTICLASS",
        modelDisplayName: "CXR-Multiclass",
      });
    }
  };

  const confirm3DAbdomen = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to generate 3D-Abdomen for ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "THREED_ABDOMEN",
        modelDisplayName: "3D-Abdomen",
      });
    }
  };

  const confirmLiverSegmentation = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run Liver-Segmentation on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "LIVER_SEGMENTATION",
        modelDisplayName: "Liver-Segmentation",
      });
    }
  };

  const confirmContourHaN = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run Contour-HaN generation on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "Contour-HaN",
        modelDisplayName: "Contour-HaN",
      });
    }
  };

  const showAIButton = (patient) => {
    const mod = (getLatestModality(patient) || "").toLowerCase();
    if (mod.includes("ct")) return true;
    if (mod.includes("xr") || mod.includes("x ray") || mod.includes("x-ray")) {
      return true;
    }
    if (mod.includes("mri") || mod.includes("mr")) return true;
    return false;
  };

  const getEnabledModels = (patient) => {
    const mod = (getLatestModality(patient) || "").toLowerCase();
    const results = {
      xrayFracture: false,
      cxrTb: false,
      cxrMulticlass: false,
      contourAbdomen: false,
      tumorAbdomen: false,
      threeDAbdomen: false,
      liverSegmentation: false,
      contourHaN: false, // Add this line
    };

    // X-ray–based models
    if (
      mod.includes("xray") ||
      mod.includes("x-ray") ||
      mod.includes("xr") ||
      mod.includes("x ray")
    ) {
      results.xrayFracture = aiModelsEnabled["XRay-Fracture"] === true;
      results.cxrTb = aiModelsEnabled["CXR-TB"] === true;
      results.cxrTb2 = aiModelsEnabled["CXR-TB2"] === true;
      results.cxrMulticlass = aiModelsEnabled["CXR-Multiclass"] === true;
    }

    // CT–based models
    if (mod.includes("ct")) {
      results.contourAbdomen = aiModelsEnabled["Contour-Abdomen"] === true;
      results.tumorAbdomen = aiModelsEnabled["Tumor-Abdomen"] === true;
      results.threeDAbdomen = aiModelsEnabled["3D-Abdomen"] === true;
      results.liverSegmentation =
        aiModelsEnabled["Liver-Segmentation"] === true;
      results.contourHaN = aiModelsEnabled["Contour-HaN"] === true;
    }

    return results;
  };

  const handleClinicalHistorySave = async () => {
    if (!selectedPatientId) return; // Ensure patient ID is selected

    const updates = {};

    // Encrypt and save the clinical history text if provided and modified
    if (
      clinicalHistoryText.trim() &&
      clinicalHistoryText !== posts[selectedPatientId].Clinical_Textarea
    ) {
      updates.Clinical_Textarea = clinicalHistoryText;
    }

    // Add the current timestamp
    updates.Clinical_Timestamp = formatDate(new Date());

    // If a new file is attached, encrypt the file URL and save
    if (attachedFile && attachedFile instanceof File) {
      const folderPath = `superadmin/admins/${adminName1}/patients/${selectedPatientId}`;
      const fileReference = storageRef(
        storage,
        `${folderPath}/clinical_history/${attachedFile.name}`
      );

      try {
        const snapshot = await uploadBytes(fileReference, attachedFile);
        const fileUrl = await getDownloadURL(snapshot.ref);

        updates.Clinical_Filepath = encrypt(fileUrl); // Encrypt the file URL before saving
      } catch (error) {
        console.error("Error uploading or encrypting file:", error);
        toast.error("Error uploading file", { position: "top-center" });
        return;
      }
    }

    // Save the updates to the database
    saveToDatabase(updates);
  };

  // Function to format the current date as DD/MM/YYYY, HH:mm:ss

  const formatDate = (input) => {
    // If it's already in dd/mm/yyyy, hh:mm:ss format, return as-is
    if (
      typeof input === "string" &&
      /^\d{2}\/\d{2}\/\d{4}, \d{2}:\d{2}:\d{2}$/.test(input)
    ) {
      return input;
    }

    // Normalize numbers (seconds -> ms)
    if (typeof input === "number") {
      // if looks like seconds (10 digits), convert to ms
      if (String(input).length === 10) input = input * 1000;
    }

    // Try to construct a Date
    let date;
    if (input instanceof Date) {
      date = input;
    } else {
      date = new Date(input);
    }

    // If invalid, return a fallback string (or "NA")
    if (isNaN(date.getTime())) {
      return "NA";
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
  };

  // Function to save the updates to the Firebase Realtime Database
  const saveToDatabase = (updates) => {
    if (Object.keys(updates).length === 0) {
      // No changes were made, so don't update
      toast.info("No changes made.", { position: "top-center" });
      return;
    }

    // Save the updates to the patient's node in Realtime Database
    const patientRef = ref(
      db,
      `superadmin/admins/${adminName1}/patients/${selectedPatientId}`
    );
    runTransaction(patientRef, (currentData) => ({
      ...currentData,
      ...updates, // Merge the updates with existing data
    }))
      .then(async () => {
        // Deepa audit logs: log clinical history update
        await logClinicalHistoryTech({
          technicianName: techname || adminName1,
          patientId: selectedPatientId, // Will be encrypted in the audit log function
          patientName: posts[selectedPatientId].FullName,
          isUpdate:
            !!posts[selectedPatientId].Clinical_Textarea ||
            !!posts[selectedPatientId].Clinical_Filepath,
          hasTextEntry: !!updates.Clinical_Textarea,
          hasFileAttachment: !!updates.Clinical_Filepath,
          success: true,
        });

        toast.success("Clinical History saved successfully", {
          position: "top-center",
        });
        setClinicalHistoryModalVisible(false); // Close the modal
        setAttachedFile(null); // Reset the attached file input
      })
      .catch(async (error) => {
        console.error("Error saving clinical history:", error);

        // Deepa audit logs: log failed clinical history update attempt
        await logClinicalHistoryTech({
          technicianName: techname || adminName1,
          patientId: selectedPatientId, // Will be encrypted in the audit log function
          patientName: posts[selectedPatientId].FullName,
          isUpdate:
            !!posts[selectedPatientId].Clinical_Textarea ||
            !!posts[selectedPatientId].Clinical_Filepath,
          hasTextEntry: !!updates.Clinical_Textarea,
          hasFileAttachment: !!updates.Clinical_Filepath,
          success: false,
          failureReason: error.message,
        });

        toast.error("Error saving clinical history", {
          position: "top-center",
        });
      });
  };

  useEffect(() => {
    const aiResultListeners = Object.keys(posts).map((patientId) => {
      const aiResultRef = ref(
        db,
        `superadmin/admins/${adminName1}/patients/${patientId}/AI_result`
      );
      return onValue(aiResultRef, (snapshot) => {
        const aiResult = snapshot.val();
        setStatusMessages((prev) => ({
          ...prev,
          [patientId]: aiResult === "true" ? "Done" : "RUN AI",
        }));
      });
    });

    return () => aiResultListeners.forEach((off) => off());
  }, [posts, adminName1]);

  const handleClinicalHistoryClick = async (id, patient) => {
    setSelectedPatientId(id);

    // Decrypt the clinical history text and file path for display
    const clinicalTextFromDB = decryptDataIfNeeded(
      patient.Clinical_Textarea || ""
    );
    const clinicalFileFromDB = decryptDataIfNeeded(
      patient.Clinical_Filepath || ""
    );

    setClinicalHistoryText(clinicalTextFromDB);
    setAttachedFile(clinicalFileFromDB ? { name: "Attached File" } : null);

    setIsEditing(!clinicalTextFromDB && !clinicalFileFromDB); // Enter edit mode if no clinical history exists

    // Deepa audit logs: log clinical history view
    try {
      await logClinicalHistoryTech({
        technicianName: techname || adminName1,
        patientId: id,
        patientName: patient.FullName,
        isView: true,
        isUpdate: false,
        hasTextEntry: !!patient.Clinical_Textarea,
        hasFileAttachment: !!patient.Clinical_Filepath,
        success: true,
      });
    } catch (err) {
      console.error("❌ Failed to write clinical history view audit log", err);
    }

    // Display the clinical history modal
    setClinicalHistoryModalVisible(true);
  };

  const hasPrescription = (id) => {
    const patient = posts[id];
    return !!patient.PrescriptionURL; // Returns true if there's a URL, false otherwise
  };

  const handledescription = (id) => {
    const patient = posts[id];
    const prescriptionURL = patient.PrescriptionURL;

    if (!prescriptionURL) {
      toast.info("No Prescription available", {
        position: "top-center",
      });
      return;
    }

    try {
      const decryptedURL = decrypt(prescriptionURL);

      if (decryptedURL) {
        window.open(decryptedURL, "_blank");
      } else {
        window.open(prescriptionURL, "_blank");
      }
    } catch (error) {
      console.error("Error decrypting or handling prescription URL:", error);
      toast.info("No Prescription available", {
        position: "top-center",
      });
    }
  };

  const getLatestPrescriptionURL = (patient) => {
    if (!patient) {
      return null;
    }

    let foundPrescriptionURL = "";
    let prescriptionSource = "";
    const patientId = patient.ID || "Unknown";
    // PRIORITY 1: Find prescription in uploads (Version 03 patients) - Check LATEST scan first
    if (patient.Version === "03" && patient.uploads) {
      const scanKeys = Object.keys(patient.uploads)
        .filter((key) => key.toLowerCase().includes("scan"))
        .map((key) => ({
          key,
          number: parseInt(key.replace(/\D/g, "")) || 0,
        }))
        .sort((a, b) => b.number - a.number); // Sort by highest number first (latest scan)

      for (const { key } of scanKeys) {
        const scanData = patient.uploads[key];
        if (!scanData) continue;
        // Check for encrypted PrescriptionURL first, then plain text
        const prescription =
          getPatientData(scanData, "PrescriptionURL") ||
          scanData.PrescriptionURL;

        if (prescription) {
          // Handle array of prescriptions (get the latest one)
          if (Array.isArray(prescription) && prescription.length > 0) {
            const latestPrescription = prescription[prescription.length - 1];
            const validLatest = getValidString(latestPrescription);
            if (validLatest) {
              foundPrescriptionURL = validLatest;
              prescriptionSource = `Latest Upload (${key})`;
              break;
            }
          }
          // Handle single prescription string
          else {
            const validPrescription = getValidString(prescription);
            if (validPrescription) {
              foundPrescriptionURL = validPrescription;
              prescriptionSource = `Latest Upload (${key})`;
              break;
            }
          }
        }
      }
    }

    // PRIORITY 2: Fallback to main patient node for prescription (both Version 03 and legacy)
    if (!foundPrescriptionURL) {
      // Try encrypted field first, then plain text field
      const mainPrescriptionURL =
        getPatientData(patient, "PrescriptionURL") || patient.PrescriptionURL;
      if (mainPrescriptionURL) {
        // Handle array of prescriptions (get the latest one)
        if (
          Array.isArray(mainPrescriptionURL) &&
          mainPrescriptionURL.length > 0
        ) {
          const latestPrescription =
            mainPrescriptionURL[mainPrescriptionURL.length - 1];
          const validLatest = getValidString(latestPrescription);
          if (validLatest) {
            foundPrescriptionURL = validLatest;
            prescriptionSource = "Main Patient Node";
          }
        }
        // Handle single prescription string
        else {
          const validPrescription = getValidString(mainPrescriptionURL);
          if (validPrescription) {
            foundPrescriptionURL = validPrescription;
            prescriptionSource = "Main Patient Node";
          }
        }
      }
    }

    // PRIORITY 3: No prescription found anywhere
    if (!foundPrescriptionURL) {
      prescriptionSource = "Not Available";
    }
    return foundPrescriptionURL || null;
  };

  const toggleDropdown = (id) => {
    setSelectedDropdownId((prevId) => (prevId === id ? null : id));
  };

  // Close the dropdown if clicked outside of it
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setSelectedDropdownId(null); // Close dropdown
    }
  };

  useEffect(() => {
    if (selectedDropdownId !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectedDropdownId]);

  const handleResetAI = async (patientId) => {
    if (
      !window.confirm(
        "Are you sure you want to reset AI results for this patient?"
      )
    )
      return;

    const patient = posts[patientId];
    if (!patient?.AI_result) return;

    // decrypt folderPath
    let folderPath = "";
    if (patient.Version === "03" && patient.uploads) {
      const scan = Object.values(patient.uploads).find(
        (s) => s.FolderPath && s.FolderPath !== "NA"
      );
      folderPath = scan ? decryptDataIfNeeded(scan.FolderPath) : "";
    } else {
      folderPath = decryptDataIfNeeded(patient.FolderPath);
    }
    if (!folderPath) {
      toast.error("No storage folder found", { position: "top-center" });
      return;
    }

    const storage = getStorage();
    const mod = getLatestModality(patient).toLowerCase();

    try {
      if (mod.includes("ct")) {
        // Contouring: recursively delete dicom-seg-[1–9].dcm
        const deleteSegRecursively = async (path) => {
          const folderRef = storageRef(storage, path);
          const { prefixes, items } = await listAll(folderRef);

          // delete seg files
          const segs = items.filter((it) =>
            /^dicom\-seg\-[1-9]\.dcm$/.test(it.name)
          );
          await Promise.all(segs.map((it) => deleteObject(it)));

          // recurse subfolders
          await Promise.all(
            prefixes.map((pref) => deleteSegRecursively(pref.fullPath))
          );
        };
        await deleteSegRecursively(folderPath);

        // Also remove 3D GLB files for CT scans
        const folderRef = storageRef(storage, folderPath);
        const { items } = await listAll(folderRef);
        const threeDFiles = items.filter((fileRef) =>
          fileRef.name.toLowerCase().endsWith(".glb")
        );
        if (threeDFiles.length > 0) {
          await Promise.all(
            threeDFiles.map((fileRef) => deleteObject(fileRef))
          );
          console.log(
            `Deleted ${threeDFiles.length} 3D GLB files from CT folder`
          );
        }

        // Also check patient root directory for GLB files (where 3D-Abdomen saves them)
        const patientRootPath = `superadmin/admins/${adminName1}/patients/${patientId}`;
        const patientRootRef = storageRef(storage, patientRootPath);
        try {
          const { items: rootItems } = await listAll(patientRootRef);
          const rootThreeDFiles = rootItems.filter((fileRef) =>
            fileRef.name.toLowerCase().endsWith(".glb")
          );
          if (rootThreeDFiles.length > 0) {
            await Promise.all(
              rootThreeDFiles.map((fileRef) => deleteObject(fileRef))
            );
            console.log(
              `Deleted ${rootThreeDFiles.length} 3D GLB files from patient root directory`
            );
          }
        } catch (error) {
          console.log(
            "No GLB files found in patient root directory or error accessing it:",
            error.message
          );
        }

        // Clear 3D file references in Realtime DB for CT scans
        const patientDbRef = ref(
          db,
          `superadmin/admins/${adminName1}/patients/${patientId}`
        );
        const patientSnapshot = await get(patientDbRef);
        const patientData = patientSnapshot.val();

        if (
          patientData &&
          patientData.Version === "03" &&
          patientData.uploads
        ) {
          // For Version 03 patients with uploads structure
          const uploads = patientData.uploads;
          const scanKeys = Object.keys(uploads).filter((key) =>
            key.toLowerCase().startsWith("scan")
          );

          // Clear 3D data from all scans
          for (const scanKey of scanKeys) {
            const scanPath3DRef = ref(
              db,
              `superadmin/admins/${adminName1}/patients/${patientId}/uploads/${scanKey}/Path3D`
            );
            const scanDicom3DURLRef = ref(
              db,
              `superadmin/admins/${adminName1}/patients/${patientId}/uploads/${scanKey}/Dicom_3DURL`
            );

            await Promise.all([
              set(scanPath3DRef, ""),
              set(scanDicom3DURLRef, ""),
            ]);
          }
        } else {
          // For legacy patients, clear patient level 3D data
          const path3DRef = ref(
            db,
            `superadmin/admins/${adminName1}/patients/${patientId}/Path3D`
          );
          const dicom3DURLRef = ref(
            db,
            `superadmin/admins/${adminName1}/patients/${patientId}/Dicom_3DURL`
          );

          await Promise.all([set(path3DRef, ""), set(dicom3DURLRef, "")]);
        }

        toast.success("AI results have been reset", { position: "top-center" });
      } else {
        // Bone/TB: delete everything under AI_Results
        const aiRef = storageRef(storage, `${folderPath}/AI_Results`);
        const { prefixes, items } = await listAll(aiRef);
        await Promise.all(items.map((it) => deleteObject(it)));
        for (const pref of prefixes) {
          const nested = await listAll(pref);
          await Promise.all(nested.items.map((it) => deleteObject(it)));
        }

        toast.success("AI results have been reset", { position: "top-center" });
      }

      // Clean up AI_Report data from Firebase Realtime Database using AIModelHandler
      await AIModelHandler.resetAIReport(patientId, adminName1);

      // flip DB flag
      await set(
        ref(
          db,
          `superadmin/admins/${adminName1}/patients/${patientId}/AI_result`
        ),
        false
      );
    } catch (err) {
      console.error("Reset AI error:", err);
      toast.error("Failed to reset AI results", { position: "top-center" });
    }
  };

  return (
    <>
      {/* New Warning Message at Top Center (shown only if any AI task is still running) */}
      {aiTasks.length > 0 &&
        aiTasks.some(
          (task) =>
            ![
              "done",
              "already done",
              "failed",
              "server down",
              "insufficient funds",
              "unknown id",
            ].includes(task.status.toLowerCase())
        ) && (
          <div
            style={{
              position: "fixed",
              top: "70px",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "#fff3f3",
              padding: "12px 24px",
              border: "2px solid #ff4d4d",
              borderRadius: "8px",
              zIndex: 10000,
              fontWeight: "bold",
              fontSize: "16px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              textAlign: "center",
            }}
          >
            AI Processing in Progress – Do not close or refresh this page.
          </div>
        )}
      {/* Main container for the component */}

      <div className="container-fluid">
        {/* ✅ Add the Top Panel Here */}
        <div className="top-panel">
          {/* ✅ Updated Logout Dropdown */}
          <Dropdown className="ml-auto">
            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
              {techname}
            </Dropdown.Toggle>
            <Dropdown.Menu className="logout-menu">
              <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        {/* Search Bar Section */}
        <div className="search-bar-containerAssignDoc">
          <Button onClick={toggleAddPatientView} className="add-patient-button">
            Add Patient
          </Button>
          <Button
            onClick={() => setBulkAssignModalVisible(true)}
            className="add-patient-button"
          >
            Bulk Assign
          </Button>

          {/* server */}

          {/* <Link
            to="/Technician/OrthancServerData"
            className="add-patient-button"
          >
            Server Data
          </Link> */}
          {/* Search Input for Patient ID */}
          <div>
            <input
              type="text"
              placeholder="🔍 Patient ID"
              value={searchTerms.patientId}
              onChange={(e) =>
                setSearchTerms((prev) => ({
                  ...prev,
                  patientId: e.target.value,
                }))
              }
              onFocus={(e) => (e.target.placeholder = "")} // Viniith Fix this 05-08-2025 - Hide placeholder on focus
              onBlur={(e) => (e.target.placeholder = "🔍 Patient ID")} // Viniith Fix this 05-08-2025 - Show placeholder on blur
              className="search-input"
            />
          </div>
          {/* Search Input for Patient Name */}
          <div>
            <input
              type="text"
              placeholder="🔍 Name"
              value={searchTerms.fullName}
              onChange={(e) =>
                setSearchTerms((prev) => ({
                  ...prev,
                  fullName: e.target.value,
                }))
              }
              onFocus={(e) => (e.target.placeholder = "")} // Viniith Fix this 05-08-2025 - Hide placeholder on focus
              onBlur={(e) => (e.target.placeholder = "🔍 Name")} // Viniith Fix this 05-08-2025 - Show placeholder on blur
              className="search-input"
            />
          </div>

          {/* Dropdown for Modality Selection */}
          <div className="table-search-bar">
            <select
              name="modality"
              value={searchTerms.modality}
              onChange={(e) =>
                setSearchTerms((prev) => ({
                  ...prev,
                  modality: e.target.value,
                }))
              }
              className="search-select"
            >
              <option value="">🔍 Modality</option>
              {[
                ...new Set(
                  Object.values(posts || {}).map((patient) => {
                    let latestModality = "";

                    if (patient?.uploads && patient.Version === "03") {
                      // Use scan index for sorting
                      const scans = Object.keys(patient.uploads)
                        .map((key) => ({
                          ...patient.uploads[key],
                          scanIndex: parseInt(key.replace("Scan ", ""), 10),
                        }))
                        .sort((a, b) => b.scanIndex - a.scanIndex); // Sort by scan index descending

                      if (
                        scans.length > 0 &&
                        typeof scans[0].Modality === "string"
                      ) {
                        latestModality = scans[0].Modality.trim();
                      }
                    } else if (typeof patient?.Modality === "string") {
                      // Use the direct modality for older versions
                      latestModality = patient.Modality.trim();
                    }

                    return latestModality.toLowerCase(); // Normalize to lowercase
                  })
                ),
              ]
                .filter(
                  (modality) =>
                    modality && ["xray", "na"].includes(modality) // Filter only XRAY and NA
                )
                .sort()
                .map((modality, index) => (
                  <option key={index} value={modality}>
                    {modality.toUpperCase()}
                  </option>
                ))}
            </select>
          </div>
        </div>
        {/* Table to Display Patients */}

        <div style={{ marginTop: "20px" }}>
          {/* Loading indicator for Firebase search */}
          {isSearchingFirebase && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px', padding: '10px', backgroundColor: '#f0f8ff', borderRadius: '5px' }}>
              <CircularProgress size={20} style={{ color: '#1976d2' }} />
              <span style={{ fontSize: '14px', color: '#666', fontWeight: '500' }}>Searching Patients...</span>
            </div>
          )}

          <div className="scrollable-table-container">
            {" "}
            <table className="ASSIGNDOCADMINPANELTABLE">
              <thead>
                {/* Table Headers */}
                <tr>
                  <th className="th-head T-NO" style={{ width: "2px" }}></th>
                  <th className="th-head T-NO">ID</th>
                  <th className="th-head T-NAME" style={{ width: "40px" }}>
                    Name
                  </th>
                  <th style={{ width: "4px" }}>Age</th>
                  <th className="th-head T-NO">Study</th>
                  <th className="th-head" style={{ width: "4px" }}>
                    Modality
                  </th>
                  <th style={{ width: "4px" }}>Study Date</th>
                  <th className="T-NO">Received</th>
                  <th className="th-head T-NO" style={{ width: "200px" }}>
                    Assigned Doctor
                  </th>
                  <th className="th-head T-NO" style={{ width: "100px" }}>
                    Assign Date
                  </th>
                  <th className="th-head T-NO" style={{ width: "100px" }}>
                    Report Date
                  </th>
                  <th className="th-head" style={{ width: "4px" }}>
                    Status
                  </th>
                  {/* <th className="th-head" style={{ width: "120px" }}>
                    AI Result
                  </th> */}
                  <th className="th-head T-No" style={{ width: "200px" }}>
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {/* Display Current Patients */}
                {currentPatients.length > 0 ? (
                  currentPatients.map((id, index) => {
                    const patient = posts[id];
                    const version = patient.Version || "1"; // Default to version "1" if not specified
                    const canShowAI = showAIButton(patient);
                    const { bone, contouring, tb } = getEnabledModels(patient);

                    let displayData = {};
                    let latestStudyDate = "NA"; // Default value for latestStudyDate
                    let latestTypeOfData = "NA"; // Default value for latestTypeOfData

                    if (version === "03" && patient.uploads) {
                      // Handle the new format with `uploads`
                      const uploads = Object.keys(patient.uploads).map(
                        (scanId) => ({
                          scanId,
                          ...patient.uploads[scanId],
                        })
                      );

                      // Sort by scan number (extract numeric part from scanId)
                      uploads.sort((a, b) => {
                        const scanNumberA = parseInt(
                          a.scanId.replace(/[^0-9]/g, ""),
                          10
                        );
                        const scanNumberB = parseInt(
                          b.scanId.replace(/[^0-9]/g, ""),
                          10
                        );
                        return scanNumberB - scanNumberA; // Latest scan number first
                      });

                      const latestUpload = uploads[0];
                      latestStudyDate = latestUpload.StudyDate || "NA"; // Update latestStudyDate
                      latestTypeOfData =
                        latestUpload.Type_of_Data ||
                        latestUpload.Type_of_CT ||
                        latestUpload.Type_of_Dicom_Data ||
                        "NA"; // Determine the latest Type_of_Data

                      displayData = {
                        ID: decrypt(patient.ID),
                        FullName: patient.FullName || "NA",
                        Age:
                          patient.Age &&
                          patient.Age !== "NaN" &&
                          String(patient.Age).toLowerCase() !== "nan"
                            ? patient.Age
                            : "NA",
                        Type_of_Data: latestTypeOfData,
                        Modality: latestUpload.Modality || "NA",
                        StudyDate: latestUpload.StudyDate || "NA",
                        Timestamp: latestUpload.uplaodtimetamp || "NA",
                        FolderPath: latestUpload.FolderPath || "NA",
                        Dicom_ReportURL: latestUpload.Dicom_ReportURL || "NA",
                      };
                    } else {
                      // Handle the old format
                      let latestModality = "NA";

                      // Modality
                      if (Array.isArray(patient.Modality)) {
                        latestModality =
                          patient.Modality[patient.Modality.length - 1];
                      } else if (typeof patient.Modality === "string") {
                        latestModality = patient.Modality;
                      }

                      // StudyDate
                      if (Array.isArray(patient.StudyDate)) {
                        latestStudyDate =
                          patient.StudyDate[patient.StudyDate.length - 1];
                      } else if (typeof patient.StudyDate === "string") {
                        latestStudyDate = patient.StudyDate;
                      }

                      // Type_of_Data
                      if (Array.isArray(patient.Type_of_CT)) {
                        latestTypeOfData =
                          patient.Type_of_CT[patient.Type_of_CT.length - 1];
                      } else if (typeof patient.Type_of_CT === "string") {
                        latestTypeOfData = patient.Type_of_CT;
                      } else if (Array.isArray(patient.Type_of_Dicom_Data)) {
                        latestTypeOfData =
                          patient.Type_of_Dicom_Data[
                            patient.Type_of_Dicom_Data.length - 1
                          ];
                      } else if (
                        typeof patient.Type_of_Dicom_Data === "string"
                      ) {
                        latestTypeOfData = patient.Type_of_Dicom_Data;
                      } else if (Array.isArray(patient.Type_of_Data)) {
                        latestTypeOfData =
                          patient.Type_of_Data[patient.Type_of_Data.length - 1];
                      } else if (typeof patient.Type_of_Data === "string") {
                        latestTypeOfData = patient.Type_of_Data;
                      }

                      displayData = {
                        ID: decrypt(patient.ID),
                        FullName: patient.FullName || "NA",
                        Age:
                          patient.Age &&
                          patient.Age !== "NaN" &&
                          String(patient.Age).toLowerCase() !== "nan"
                            ? patient.Age
                            : "NA",
                        Type_of_Data: latestTypeOfData,
                        Modality: latestModality,
                        StudyDate: latestStudyDate,
                        Timestamp: patient.Timestamp || "NA",
                        FolderPath: patient.FolderPath || "NA",
                        Dicom_ReportURL: patient.Dicom_ReportURL || "NA",
                      };
                    }
                    return (
                      <tr key={index}>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {patient.Clinical_Textarea ||
                            patient.Clinical_Filepath ? (
                              <Tooltip title="View Clinical History" arrow>
                                <HistoryIcon
                                  className="clinical-history-icon"
                                  onClick={() =>
                                    handleClinicalHistoryClick(id, patient)
                                  }
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "xl-large",
                                  }}
                                />
                              </Tooltip>
                            ) : (
                              <Tooltip title="Add Clinical History" arrow>
                                <AddIcon
                                  className="clinical-history-icon"
                                  onClick={() =>
                                    handleClinicalHistoryClick(id, patient)
                                  }
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "xl-large",
                                  }}
                                />
                              </Tooltip>
                            )}
                          </div>
                        </td>
                        <td>
                          <p className="study-column-wrap">
                          {hasDicomFolder(patient) ? (
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleScan(patient);
                              }}
                            >
                              {decrypt(patient.ID)}
                            </a>
                          ) : (
                            <span style={{ color: "grey" }}>
                              {decrypt(patient.ID)}
                            </span>
                          )}
                          </p>
                        </td>
                        <td className="admin-nameAssignDoc">
                          <p className="study-column-wrap">{patient.FullName}</p>
                        </td>
                        <td>
                          {patient.Age &&
                          patient.Age !== "NaN" &&
                          String(patient.Age).toLowerCase() !== "nan"
                            ? patient.Age
                            : "NA"}
                        </td>
                        <td>
                          <p className="study-column-wrap">
                          {displayData.Type_of_Data ||
                            displayData.Type_of_CT ||
                            displayData.Type_of_Dicom_Data ||
                            "NA"}
                            </p>
                        </td>
                        {/* <td>{patient.Modality || "NA"}</td> */}
                        <td>{displayData.Modality}</td>
                        <td>{latestStudyDate}</td>
                        {/* Display latestStudyDate */}
                        <td>
                          {patient.Timestamp
                            ? (() => {
                                const formattedTimestamp = formatTimestampForDisplay(patient.Timestamp);
                                const [date, time] = formattedTimestamp.split(", ");
                                return (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <span>{date}</span>
                                    {time && <span>{time}</span>}
                                  </div>
                                );
                              })()
                            : "NA"}
                        </td>
                        {/* deepa fix ui - DropdownCell now returns its own <td>, no wrapper needed */}
                        <DropdownCell
                          id={id}
                          patient={patient}
                          doctors={doctors}
                          selectedDropdownId={selectedDropdownId}
                          toggleDropdown={toggleDropdown}
                          handleAssignDoctor={handleAssignDoctor}
                        />
                        {/* Assign Date */}
                        <td>
                          {patient.DoctorAssigned &&
                          patient.DoctorAssigned.length > 0
                            ? (() => {
                                // Find the latest assigned doctor (most recent assignedAt)
                                const latestDoctor =
                                  patient.DoctorAssigned.filter(
                                    (doctor) =>
                                      typeof doctor === "object" &&
                                      (doctor.assignedAt || doctor.timestamp)
                                  ).sort((a, b) => {
                                    const dateA = new Date(
                                      a.assignedAt || a.timestamp
                                    );
                                    const dateB = new Date(
                                      b.assignedAt || b.timestamp
                                    );
                                    return dateB - dateA; // Sort descending (latest first)
                                  })[0];

                                if (latestDoctor) {
                                  const assignedDateTime = latestDoctor.assignedAt ||
                                    formatDate(new Date(latestDoctor.timestamp));
                                  
                                  const splitDateTime = (dt) => {
                                    if (!dt || typeof dt !== "string")
                                      return { date: dt || "NA", time: "" };
                                    if (dt.includes(", ")) {
                                      const [date, time] = dt.split(", ");
                                      return { date, time };
                                    }
                                    const lastSpace = dt.lastIndexOf(" ");
                                    if (lastSpace > 0) {
                                      return {
                                        date: dt.slice(0, lastSpace),
                                        time: dt.slice(lastSpace + 1),
                                      };
                                    }
                                    return { date: dt, time: "" };
                                  };
                                  
                                  const { date, time } = splitDateTime(assignedDateTime);
                                  return (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <span>{date}</span>
                                      {time && <span>{time}</span>}
                                    </div>
                                  );
                                }
                                return "NA";
                              })()
                            : "NA"}
                        </td>
                        {/* Report Date */}
                        <td>
                          {patient.Report_TimeStamp && patient.Report_TimeStamp !== "NA"
                            ? (() => {
                                const [date, time] = patient.Report_TimeStamp.split(", ");
                                return (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <span>{date}</span>
                                    {time && <span>{time}</span>}
                                  </div>
                                );
                              })()
                            : "NA"}
                        </td>
                        {/* Status */}
                        <td>{patient.Report_Status || "NA"}</td>
                        {/* AI Result */}
                        {/* <td>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "100%",
                              height: "100%",
                              textAlign: "center",
                            }}
                          >
                            {getAIClassification(patient)}
                          </div>
                        </td> */}
                        {/* Action */}
                        <td>
                          <div className="action-icons">
                            {(() => {
                              // Simply check the Dicom_ReportURL that was already processed in useEffect
                              const validReportURL = getValidString(
                                patient.Dicom_ReportURL
                              );
                              const reportAvailable = !!validReportURL;

                              if (reportAvailable) {
                                return (
                                  <>
                                    {/* View Report */}
                                    <Tooltip title="Report" arrow>
                                      <VisibilityIcon
                                        onClick={() =>
                                          handleReport(patient, "view")
                                        }
                                        style={{
                                          cursor: "pointer",
                                          marginRight: "10px",
                                        }}
                                      />
                                    </Tooltip>
                                    {/* Download Report */}
                                    <Tooltip title="Download Report" arrow>
                                      <DownloadIcon
                                        onClick={() =>
                                          handleReport(patient, "download")
                                        }
                                        style={{
                                          cursor: "pointer",
                                          marginRight: "10px",
                                        }}
                                      />
                                    </Tooltip>
                                  </>
                                );
                              } else {
                                return (
                                  <>
                                    {/* Report not available */}
                                    <Tooltip title="Report not available" arrow>
                                      <VisibilityOffOutlinedIcon
                                        onClick={() =>
                                          toast.info("Report not available", {
                                            position: "top-center",
                                          })
                                        }
                                        style={{
                                          cursor: "not-allowed",
                                          marginRight: "10px",
                                          color: "gray",
                                        }}
                                      />
                                    </Tooltip>
                                    <Tooltip title="File not available" arrow>
                                      <FileDownloadOffOutlinedIcon
                                        onClick={() =>
                                          toast.info("File not available", {
                                            position: "top-center",
                                          })
                                        }
                                        style={{
                                          cursor: "not-allowed",
                                          marginRight: "10px",
                                          color: "gray",
                                        }}
                                      />
                                    </Tooltip>
                                  </>
                                );
                              }
                            })()}
                            {/* Share Link */}
                            <Tooltip title="Share" arrow>
                              <ShareIcon
                                onClick={() => handleShareClick(id)}
                                style={{
                                  cursor: "pointer",
                                  marginRight: "10px",
                                }}
                              />
                            </Tooltip>

                            {/* Prescription icon */}
                            {(() => {
                              // Get the latest prescription URL (works for both Version "03" and older versions)
                              const latestPrescription =
                                getLatestPrescriptionURL(patient);
                              // Decrypt it if needed (it should already be decrypted from the useEffect—but this is extra precaution)
                              const decryptedPrescription = latestPrescription
                                ? decryptDataIfNeeded(latestPrescription)
                                : null;

                              return decryptedPrescription ? (
                                <Tooltip title="Prescription" arrow>
                                  <FontAwesomeIcon
                                    icon={faPrescription}
                                    onClick={async () => {
                                      console.log(
                                        "RX icon clicked - prescription available:",
                                        decryptedPrescription
                                      );
                                      try {
                                        window.open(
                                          decryptedPrescription,
                                          "_blank"
                                        );
                                        console.log(
                                          "About to call logViewPrescriptionTechnician for success"
                                        );
                                        await logViewPrescriptionTechnician({
                                          technicianName:
                                            techname || "UnknownTechnician",
                                          patientId: patient.ID,
                                          patientName: patient.FullName,
                                          prescriptionUrl:
                                            decryptedPrescription,
                                          success: true,
                                        });
                                        console.log(
                                          "logViewPrescriptionTechnician called successfully"
                                        );
                                      } catch (error) {
                                        console.error(
                                          "Error in RX click handler:",
                                          error
                                        );
                                        await logViewPrescriptionTechnician({
                                          technicianName:
                                            techname || "UnknownTechnician",
                                          patientId: patient.ID,
                                          patientName: patient.FullName,
                                          prescriptionUrl:
                                            decryptedPrescription,
                                          success: false,
                                          failureReason:
                                            error.message || "Unknown error",
                                        });
                                      }
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "10px",
                                      fontSize: "12px",
                                      color: "black",
                                      opacity: 1,
                                    }}
                                  />
                                </Tooltip>
                              ) : (
                                <Tooltip
                                  title="No Prescription Available"
                                  arrow
                                >
                                  <FontAwesomeIcon
                                    icon={faPrescription}
                                    onClick={async () => {
                                      console.log(
                                        "RX icon clicked - no prescription available"
                                      );
                                      toast.info("No prescription available", {
                                        position: "top-center",
                                      });
                                      console.log(
                                        "About to call logViewPrescriptionTechnician for failure"
                                      );
                                      await logViewPrescriptionTechnician({
                                        technicianName:
                                          techname || "UnknownTechnician",
                                        patientId: patient.ID,
                                        patientName: patient.FullName,
                                        prescriptionUrl: "",
                                        success: false,
                                        failureReason:
                                          "No prescription available",
                                      });
                                      console.log(
                                        "logViewPrescriptionTechnician called for failure case"
                                      );
                                    }}
                                    style={{
                                      cursor: "not-allowed",
                                      marginRight: "10px",
                                      fontSize: "12px",
                                      color: "gray",
                                      opacity: 0.5,
                                    }}
                                  />
                                </Tooltip>
                              );
                            })()}

                            {/* Upload & Run AI */}
                            <Tooltip title="Upload Data" arrow>
                              <Link
                                to={`/Technician/AddImage${patient.id}?page=${currentPage}`}
                              >
                                <UploadFileOutlinedIcon
                                  style={{ color: "black" }}
                                />
                              </Link>
                            </Tooltip>

                            {/* AI */}
                            {canShowAI ? (
                              <Tooltip
                                title={
                                  patient.AI_result
                                    ? "Already generated"
                                    : "Generate AI"
                                }
                                arrow
                              >
                                <span>
                                  <button
                                    onClick={() => handleAI(id)}
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "10px",
                                    }}
                                    disabled={Boolean(patient.AI_result)}
                                  >
                                    AI
                                  </button>
                                </span>
                              </Tooltip>
                            ) : null}

                            {/* {patient.AI_result && (
                              <Tooltip title="Reset AI Results" arrow>
                                <RestartAltIcon
                                  onClick={() => handleResetAI(id)}
                                  style={{ cursor: "pointer" }}
                                />
                              </Tooltip>
                            )} */}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="15" className="text-center">
                      {isLoadingBatch ? (
                        <div style={{ padding: "20px" }}>
                          <CircularProgress size={30} />
                          <p style={{ marginTop: "10px" }}>Loading patients...</p>
                        </div>
                      ) : (
                        "No patients found."
                      )}
                    </td>
                  </tr>
                )}
                {/* Show loading indicator when fetching more batches */}
                {isLoadingBatch && currentPatients.length > 0 && (
                  <tr>
                    <td colSpan="15" className="text-center" style={{ padding: "10px" }}>
                      <CircularProgress size={20} style={{ marginRight: "10px" }} />
                      Loading more patients...
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              marginTop: "20px",
              gap: "15px",
            }}
          >
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(event, value) => paginate(value)}
              siblingCount={1}
              boundaryCount={1}
              color="primary"
              showFirstButton
              showLastButton={false}
            />
            
            {isLoadingBatch && (
              <div style={{
                padding: "10px 20px",
                fontSize: "14px",
                color: "#007bff",
                fontWeight: "600",
              }}>
                Loading more patients...
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Modal for Clinical History */}
      {clinicalHistoryModalVisible && (
        <div
          className="ClinicalHistory-modal-background"
          onClick={() => setClinicalHistoryModalVisible(false)}
        >
          <div
            className="ClinicalHistory-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ClinicalHistory-modal-header">
              <h2>
                {selectedPatientId &&
                (posts[selectedPatientId].Clinical_Textarea ||
                  posts[selectedPatientId].Clinical_Filepath)
                  ? "View"
                  : "Add"}{" "}
                Clinical History
              </h2>
              <span
                className="ClinicalHistory-close-btn"
                onClick={() => setClinicalHistoryModalVisible(false)}
              >
                &times;
              </span>
            </div>

            <div className="ClinicalHistory-modal-body">
              {(posts[selectedPatientId].Clinical_Textarea || isEditing) && (
                <div className="form-group">
                  <label htmlFor="clinicalHistoryTextarea">
                    Clinical History:
                  </label>
                  <textarea
                    id="clinicalHistoryTextarea"
                    value={clinicalHistoryText}
                    onChange={(e) => setClinicalHistoryText(e.target.value)}
                    className="form-control"
                    rows="4"
                    readOnly={!isEditing}
                  />
                </div>
              )}

              {!isEditing && posts[selectedPatientId].Clinical_Filepath && (
                <div className="form-group">
                  <label>Attached File:</label>
                  <div>
                    <a
                      href={decryptDataIfNeeded(
                        posts[selectedPatientId].Clinical_Filepath
                      )}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Show File
                    </a>
                  </div>
                </div>
              )}

              {isEditing && (
                <div className="form-group">
                  <label htmlFor="attachFileInput">Attach File:</label>
                  <input
                    type="file"
                    id="attachFileInput"
                    onChange={(e) => setAttachedFile(e.target.files[0])}
                    className="form-control"
                  />
                </div>
              )}
            </div>

            <div className="ClinicalHistory-modal-footer">
              {isEditing && (
                <>
                  <Button
                    variant="success"
                    onClick={() => handleClinicalHistorySave()}
                    disabled={!clinicalHistoryText && !attachedFile}
                  >
                    Save
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setIsEditing(false);
                      if (
                        !posts[selectedPatientId].Clinical_Textarea &&
                        !posts[selectedPatientId].Clinical_Filepath
                      ) {
                        setClinicalHistoryModalVisible(false);
                      }
                    }}
                  >
                    Cancel
                  </Button>
                </>
              )}

              {!isEditing &&
                (posts[selectedPatientId].Clinical_Textarea ||
                  posts[selectedPatientId].Clinical_Filepath) && (
                  <Button variant="primary" onClick={() => setIsEditing(true)}>
                    Edit
                  </Button>
                )}
            </div>
          </div>
        </div>
      )}
      {/* Modal for Bulk Assign */}
      {bulkAssignModalVisible && (
        <div
          className="BulkAssignDoc-modal-background"
          onClick={() => setBulkAssignModalVisible(false)}
        >
          <div
            className="BulkAssignDoc-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="BulkAssignDoc-modal-header">
              <h2>Assign Patients in Bulk</h2>
              <span
                className="BulkAssignDoc-close-btn"
                onClick={() => setBulkAssignModalVisible(false)}
              >
                &times;
              </span>
            </div>
            <div className="BulkAssignDoc-modal-body">
              <h3>Select Patients</h3>
              <input
                type="checkbox"
                onChange={(e) => {
                  if (e.target.checked) {
                    setBulkSelectedPatients(unassignedPatients);
                  } else {
                    setBulkSelectedPatients([]);
                  }
                }}
                checked={
                  bulkSelectedPatients.length === unassignedPatients.length
                }
              />
              <label>Select All</label>
              <ul>
                {unassignedPatients.map((id) => (
                  <li key={id}>
                    <input
                      type="checkbox"
                      checked={bulkSelectedPatients.includes(id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setBulkSelectedPatients((prev) => [...prev, id]);
                        } else {
                          setBulkSelectedPatients((prev) =>
                            prev.filter((patientId) => patientId !== id)
                          );
                        }
                      }}
                    />
                    {posts[id].FullName} ({posts[id].ID})
                  </li>
                ))}
              </ul>
              <h3>Select Doctor</h3>
              <select
                value={bulkSelectedDoctor}
                onChange={(e) => setBulkSelectedDoctor(e.target.value)}
              >
                <option value="">Select Doctor</option>
                {(() => {
                  // Check if there are any HOD doctors in the system
                  const hasHODDoctors = Object.keys(doctors).some(
                    (doctorKey) => {
                      const doctorRole = doctors[doctorKey].Role;
                      return (
                        doctorRole && doctorRole.toLowerCase().includes("hod")
                      );
                    }
                  );

                  const doctorOptions = [];
                  let hodShown = false;

                  // Show HOD option only once if there are HOD doctors
                  if (hasHODDoctors && !hodShown) {
                    doctorOptions.push(
                      <option key="hod-option" value="HOD">
                        HOD
                      </option>
                    );
                    hodShown = true;
                  }

                  // Show other doctors (non-HOD)
                  Object.keys(doctors).forEach((doctorKey) => {
                    const doctorName = doctors[doctorKey].Name;
                    const doctorRole = doctors[doctorKey].Role;
                    const isHOD =
                      doctorRole && doctorRole.toLowerCase().includes("hod");
                    const isDoctorCommon =
                      doctorRole &&
                      doctorRole.toLowerCase().includes("doctorcommon");

                    // Skip DoctorCommon and HOD doctors (HOD already handled above)
                    if (isDoctorCommon || isHOD) {
                      return;
                    }

                    doctorOptions.push(
                      <option key={doctorKey} value={doctorName}>
                        {doctorName}
                      </option>
                    );
                  });

                  return doctorOptions;
                })()}
              </select>
            </div>
            <div className="BulkAssignDoc-modal-footer">
              <Button
                variant="success"
                onClick={() => handleBulkAssign()}
                disabled={!bulkSelectedPatients.length || !bulkSelectedDoctor}
              >
                Assign
              </Button>
            </div>
          </div>
        </div>
      )}

      {modalVisible && (
        <div
          className="PatientViewData modal-background"
          onClick={() => setModalVisible(false)}
        >
          <div
            className="PatientViewData modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h2>Share Patient Link</h2>
              <span
                className="close-btn"
                onClick={() => setModalVisible(false)}
              >
                &times;
              </span>
            </div>
            <div className="modal-body">
              <p>Select how you'd like to share:</p>
              <button
                onClick={copyToClipboard}
                className="modal-button copy-link"
              >
                <i className="fas fa-copy" style={{ marginRight: "8px" }}></i>{" "}
                Copy Link
              </button>
              <button
                onClick={shareViaWhatsApp}
                className="modal-button whatsapp-share"
              >
                <i
                  className="fab fa-whatsapp"
                  style={{ marginRight: "8px" }}
                ></i>{" "}
                WhatsApp
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Chat Notifications */}
      <ChatNot />
      {/* AI Model Modal */}
      {aiModalVisible && aiModalPatientId && (
        <div
          className="ai-modal-overlay"
          onClick={() => {
            setAiModalVisible(false);
          }}
        >
          <div
            className="ai-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ai-modal-header">
              <h2>Select AI Model</h2>
              <button
                className="close-btn"
                onClick={() => {
                  setAiModalVisible(false);
                }}
              >
                &times;
              </button>
            </div>
            <div className="ai-modal-body">
              {(() => {
                const patient = posts[aiModalPatientId];
                const {
                  xrayFracture,
                  cxrTb,
                  cxrMulticlass,
                  contourAbdomen,
                  tumorAbdomen,
                  threeDAbdomen,
                  liverSegmentation,
                  contourHaN,
                  cxrTb2,
                } = getEnabledModels(patient);
                const mod = (getLatestModality(patient) || "").toLowerCase();
                const isXray =
                  mod.includes("xray") ||
                  mod.includes("x-ray") ||
                  mod.includes("xr") ||
                  mod.includes("x ray");
                const isCT = mod.includes("ct");

                return (
                  <ul>
                    {/* X-ray models */}
                    {isXray && (
                      <>
                        {/* CXR-Multiclass (displayed as CXR-TB-3) */}
                        {cxrMulticlass && (
                          <li
                            onClick={() =>
                              cxrMulticlass
                                ? confirmCxrMulticlass(aiModalPatientId)
                                : null
                            }
                            className="ai-model-option"
                            style={{
                              opacity: cxrMulticlass ? 1 : 0.5,
                              cursor: cxrMulticlass ? "pointer" : "not-allowed",
                            }}
                          >
                            CXR-TB-3
                          </li>
                        )}
                      </>
                    )}
                    {/* Other X-ray models - COMMENTED OUT */}
                    {/* {isXray && (
                      <>
                        {/* XRay-Fracture * /}
                        <li
                          onClick={() =>
                            xrayFracture
                              ? confirmBoneFracture(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: xrayFracture ? 1 : 0.5,
                            cursor: xrayFracture ? "pointer" : "not-allowed",
                          }}
                        >
                          XRay-Fracture
                        </li>

                        {/* CXR-TB * /}
                        <li
                          onClick={() =>
                            cxrTb ? confirmTBDetection(aiModalPatientId) : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: cxrTb ? 1 : 0.5,
                            cursor: cxrTb ? "pointer" : "not-allowed",
                          }}
                        >
                          CXR-TB
                        </li>

                        {/* CXR-TB2 * /}
                        <li
                          onClick={() =>
                            cxrTb2
                              ? confirmTB2Detection(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: cxrTb2 ? 1 : 0.5,
                            cursor: cxrTb2 ? "pointer" : "not-allowed",
                          }}
                        >
                          CXR-TB2
                        </li>

                        {/* CXR-Multiclass * /}
                        <li
                          onClick={() =>
                            cxrMulticlass
                              ? confirmCxrMulticlass(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: cxrMulticlass ? 1 : 0.5,
                            cursor: cxrMulticlass ? "pointer" : "not-allowed",
                          }}
                        >
                          CXR-Multiclass
                        </li>
                      </>
                    )} */}

                    {isCT && (
                      <>
                        {/* Contour-Abdomen */}
                        <li
                          onClick={() =>
                            contourAbdomen
                              ? confirmContouringAbdomen(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: contourAbdomen ? 1 : 0.5,
                            cursor: contourAbdomen ? "pointer" : "not-allowed",
                          }}
                        >
                          Contour-Abdomen
                        </li>

                        {/* Tumor-Abdomen - COMMENTED OUT */}
                        {/* <li
                          onClick={() =>
                            tumorAbdomen
                              ? confirmAbdomenTumorAnalysis(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: tumorAbdomen ? 1 : 0.5,
                            cursor: tumorAbdomen ? "pointer" : "not-allowed",
                          }}
                        >
                          Tumor-Abdomen
                        </li> */}

                        {/* 3D-Abdomen - COMMENTED OUT */}
                        {/* <li
                          onClick={() =>
                            threeDAbdomen
                              ? confirm3DAbdomen(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: threeDAbdomen ? 1 : 0.5,
                            cursor: threeDAbdomen ? "pointer" : "not-allowed",
                          }}
                        >
                          3D-Abdomen
                        </li> */}

                        {/* Liver-Segmentation - COMMENTED OUT */}
                        {/* <li
                          onClick={() =>
                            liverSegmentation
                              ? confirmLiverSegmentation(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: liverSegmentation ? 1 : 0.5,
                            cursor: liverSegmentation
                              ? "pointer"
                              : "not-allowed",
                          }}
                        >
                          Liver-Segmentation
                        </li> */}

                        {/* Contour-HaN */}
                        <li
                          onClick={() =>
                            contourHaN
                              ? confirmContourHaN(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: contourHaN ? 1 : 0.5,
                            cursor: contourHaN ? "pointer" : "not-allowed",
                          }}
                        >
                          Contour-HaN
                        </li>
                      </>
                    )}
                  </ul>
                );
              })()}
            </div>
            <div className="ai-modal-footer">
              <button
                onClick={() => {
                  setAiModalVisible(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Floating button to open AI tasks (only if we have tasks but the modal is fully closed) */}
      {aiTasks.length > 0 && !aiProcessingModalOpen && (
        <button
          className="open-ai-tasks-btn"
          onClick={() => setAiProcessingModalOpen(true)}
        >
          AI Tasks
        </button>
      )}

      {/* AI Processing Status Modal */}
      {aiTasks.length > 0 && aiProcessingModalOpen && (
        <div
          className="ai-processing-modal-overlay"
          style={{ display: aiProcessingModalMinimized ? "none" : "flex" }}
          onClick={() => {
            // click outside to close? Up to you if you want that.
            // setAiProcessingModalOpen(false);
          }}
        >
          <div
            className="ai-processing-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ai-processing-modal-header">
              <h3>AI Processing Status</h3>
              {/* <p style={{ color: "red", fontWeight: "bold" }}>
                 DO NOT CLOSE OR RELOAD THIS PAGE
               </p> */}
              <div className="ai-processing-header-buttons">
                <button
                  className="minimize-icon-btn"
                  onClick={() => setAiProcessingModalMinimized(true)}
                  title="Minimize"
                >
                  <MinimizeIcon />
                </button>
                {/* <button onClick={() => setAiProcessingModalOpen(false)}>
                   Close
                 </button> */}
              </div>
            </div>
            <div className="ai-processing-modal-body">
              {aiTasks.map((task, idx) => (
                <div key={idx} className="ai-task-item">
                  <div>
                    <strong>Patient ID:</strong> {task.patientId}
                  </div>
                  <div>
                    <strong>Model:</strong> {task.model || "N/A"}
                    {task.subModel ? ` (${task.subModel})` : ""}
                  </div>
                  <div>
                    <strong>Status:</strong> {task.status}
                    {task.status &&
                      task.status.toLowerCase().includes("in-progress") && (
                        <CircularProgress
                          size={16}
                          style={{ color: "#000", marginLeft: "5px" }}
                        />
                      )}
                  </div>
                  {(task.status.toLowerCase() === "done" ||
                    task.status.toLowerCase() === "failed" ||
                    task.status.toLowerCase() === "insufficient funds" ||
                    task.status.toLowerCase() === "server down" ||
                    task.status.toLowerCase() === "unknown id") && (
                    <button
                      className="clear-style-btn"
                      onClick={() => handleClearTask(idx)}
                    >
                      Clear
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Minimized Bar for AI Processing (if user hits "Minimize" but not "Close") */}
      {aiTasks.length > 0 &&
        aiProcessingModalOpen &&
        aiProcessingModalMinimized && (
          <div
            className="ai-processing-minimized-bar"
            onClick={() => setAiProcessingModalMinimized(false)}
          >
            <span style={{ fontWeight: "bold" }}>
              AI Tasks (click to expand)
            </span>
          </div>
        )}
      <ToastContainer />
    </>
  );
};

export default ListOfPatient;
